const restaurantListData = [
  {
    "info": {
      "id": "657322",
      "name": "Chinese Wok",
      "cloudinaryImageId": "e0839ff574213e6f35b3899ebf1fc597",
      "locality": "Dussehra Ground",
      "areaName": "PM Mall",
      "costForTwo": "₹250 for two",
      "cuisines": [
        "Chinese",
        "Asian",
        "Tibetan",
        "Desserts"
      ],
      "avgRating": 4.2,
      "parentId": "61955",
      "avgRatingString": "4.2",
      "totalRatingsString": "1.5K+",
      "sla": {
        "deliveryTime": 29,
        "lastMileTravel": 4.5,
        "serviceability": "SERVICEABLE",
        "slaString": "25-30 mins",
        "lastMileTravelString": "4.5 km",
        "iconType": "ICON_TYPE_EMPTY"
      },
      "availability": {
        "nextCloseTime": "2026-01-31 01:00:00",
        "opened": true
      },
      "badges": {
        "imageBadges": [
          {
            "imageId": "Rxawards/_CATEGORY-Chinese.png",
            "description": "Delivery!"
          }
        ]
      },
      "isOpen": true,
      "type": "F",
      "badgesV2": {
        "entityBadges": {
          "imageBased": {
            "badgeObject": [
              {
                "attributes": {
                  "description": "Delivery!",
                  "imageId": "Rxawards/_CATEGORY-Chinese.png"
                }
              }
            ]
          },
          "textBased": {

          },
          "textExtendedBadges": {

          }
        }
      },
      "aggregatedDiscountInfoV3": {
        "header": "ITEMS",
        "subHeader": "AT ₹119"
      },
      "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
          "lottie": {

          },
          "video": {

          }
        }
      },
      "reviewsSummary": {

      },
      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      "restaurantOfferPresentationInfo": {

      },
      "externalRatings": {
        "aggregatedRating": {
          "rating": "--"
        }
      },
      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
    },
    "analytics": {
      "context": "seo-data-667c4178-dcb5-482b-a3d1-7c54f6f8faca"
    },
    "cta": {
      "link": "https://www.swiggy.com/city/faridabad/chinese-wok-dussehra-ground-pm-mall-rest657322",
      "type": "WEBLINK"
    }
  },
  {
    "info": {
      "id": "65081",
      "name": "Theobroma",
      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2026/1/6/4438b1d2-3a7e-43dc-837f-18fc4d00d530_65081.JPG",
      "locality": "Sector 15",
      "areaName": "Sector 15",
      "costForTwo": "₹400 for two",
      "cuisines": [
        "Bakery",
        "Desserts"
      ],
      "avgRating": 4.6,
      "parentId": "1040",
      "avgRatingString": "4.6",
      "totalRatingsString": "7.9K+",
      "sla": {
        "deliveryTime": 24,
        "lastMileTravel": 4.2,
        "serviceability": "SERVICEABLE",
        "slaString": "20-25 mins",
        "lastMileTravelString": "4.2 km",
        "iconType": "ICON_TYPE_EMPTY"
      },
      "availability": {
        "nextCloseTime": "2026-01-30 23:00:00",
        "opened": true
      },
      "badges": {
        "imageBadges": [
          {
            "imageId": "Rxawards/_CATEGORY-Desserts.png",
            "description": "Delivery!"
          },
          {
            "imageId": "newg.png",
            "description": "Gourmet"
          }
        ]
      },
      "isOpen": true,
      "type": "F",
      "badgesV2": {
        "entityBadges": {
          "imageBased": {
            "badgeObject": [
              {
                "attributes": {
                  "description": "Delivery!",
                  "imageId": "Rxawards/_CATEGORY-Desserts.png"
                }
              },
              {
                "attributes": {
                  "description": "Gourmet",
                  "imageId": "newg.png"
                }
              }
            ]
          },
          "textBased": {

          },
          "textExtendedBadges": {

          }
        }
      },
      "aggregatedDiscountInfoV3": {
        "header": "50% OFF",
        "discountTag": "FLAT DEAL"
      },
      "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
          "lottie": {

          },
          "video": {

          }
        }
      },
      "reviewsSummary": {

      },
      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      "restaurantOfferPresentationInfo": {

      },
      "externalRatings": {
        "aggregatedRating": {
          "rating": "4.1",
          "ratingCount": "473"
        },
        "source": "GOOGLE",
        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
      },
      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
    },
    "analytics": {
      "context": "seo-data-667c4178-dcb5-482b-a3d1-7c54f6f8faca"
    },
    "cta": {
      "link": "https://www.swiggy.com/city/faridabad/theobroma-sector-15-rest65081",
      "type": "WEBLINK"
    }
  },
  {
    "info": {
      "id": "637287",
      "name": "The Belgian Waffle Co.",
      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/6/16/8fa53ae0-16d6-4185-9380-b982f505a1d0_637287.jpg",
      "locality": "Shopping Centre Market",
      "areaName": "Sector 15",
      "costForTwo": "₹200 for two",
      "cuisines": [
        "Waffle",
        "Desserts",
        "Ice Cream",
        "Beverages"
      ],
      "avgRating": 4.4,
      "veg": true,
      "parentId": "2233",
      "avgRatingString": "4.4",
      "totalRatingsString": "1.7K+",
      "sla": {
        "deliveryTime": 31,
        "lastMileTravel": 4.3,
        "serviceability": "SERVICEABLE",
        "slaString": "30-40 mins",
        "lastMileTravelString": "4.3 km",
        "iconType": "ICON_TYPE_EMPTY"
      },
      "availability": {
        "nextCloseTime": "2026-01-31 02:00:00",
        "opened": true
      },
      "badges": {
        "imageBadges": [
          {
            "imageId": "v1695133679/badges/Pure_Veg111.png",
            "description": "pureveg"
          }
        ]
      },
      "isOpen": true,
      "type": "F",
      "badgesV2": {
        "entityBadges": {
          "imageBased": {
            "badgeObject": [
              {
                "attributes": {
                  "description": "pureveg",
                  "imageId": "v1695133679/badges/Pure_Veg111.png"
                }
              }
            ]
          },
          "textBased": {

          },
          "textExtendedBadges": {

          }
        }
      },
      "aggregatedDiscountInfoV3": {
        "header": "20% OFF",
        "subHeader": "UPTO ₹50"
      },
      "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
          "lottie": {

          },
          "video": {

          }
        }
      },
      "reviewsSummary": {

      },
      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      "restaurantOfferPresentationInfo": {

      },
      "externalRatings": {
        "aggregatedRating": {
          "rating": "--"
        }
      },
      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
    },
    "analytics": {
      "context": "seo-data-667c4178-dcb5-482b-a3d1-7c54f6f8faca"
    },
    "cta": {
      "link": "https://www.swiggy.com/city/faridabad/the-belgian-waffle-co-shopping-centre-market-sector-15-rest637287",
      "type": "WEBLINK"
    }
  },
  {
    "info": {
      "id": "780926",
      "name": "Subway",
      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/6/12/f704c306-98e9-4b9c-a0d6-39a019a147fe_780926.jpg",
      "locality": "Mehta Road",
      "areaName": "Pacific Mall of Faridabad",
      "costForTwo": "₹350 for two",
      "cuisines": [
        "sandwich",
        "Salads",
        "wrap",
        "Healthy Food"
      ],
      "avgRating": 4.2,
      "parentId": "2",
      "avgRatingString": "4.2",
      "totalRatingsString": "780",
      "sla": {
        "deliveryTime": 30,
        "lastMileTravel": 4.3,
        "serviceability": "SERVICEABLE",
        "slaString": "25-30 mins",
        "lastMileTravelString": "4.3 km",
        "iconType": "ICON_TYPE_EMPTY"
      },
      "availability": {
        "nextCloseTime": "2026-01-30 23:00:00",
        "opened": true
      },
      "badges": {

      },
      "isOpen": true,
      "type": "F",
      "badgesV2": {
        "entityBadges": {
          "imageBased": {

          },
          "textBased": {

          },
          "textExtendedBadges": {

          }
        }
      },
      "aggregatedDiscountInfoV3": {
        "header": "ITEMS",
        "subHeader": "AT ₹69"
      },
      "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
          "lottie": {

          },
          "video": {

          }
        }
      },
      "reviewsSummary": {

      },
      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      "restaurantOfferPresentationInfo": {

      },
      "externalRatings": {
        "aggregatedRating": {
          "rating": "--"
        }
      },
      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
    },
    "analytics": {
      "context": "seo-data-667c4178-dcb5-482b-a3d1-7c54f6f8faca"
    },
    "cta": {
      "link": "https://www.swiggy.com/city/faridabad/subway-mehta-road-pacific-mall-of-faridabad-rest780926",
      "type": "WEBLINK"
    }
  },
  {
    "info": {
      "id": "56999",
      "name": "La Pino'z Pizza",
      "cloudinaryImageId": "mzb8tq7ccskyvadm9mt2",
      "locality": "Sector 15",
      "areaName": "Sector 15",
      "costForTwo": "₹250 for two",
      "cuisines": [
        "Pizzas",
        "Pastas",
        "Italian",
        "Desserts",
        "Beverages"
      ],
      "avgRating": 4.2,
      "parentId": "4961",
      "avgRatingString": "4.2",
      "totalRatingsString": "19K+",
      "sla": {
        "deliveryTime": 27,
        "lastMileTravel": 4.6,
        "serviceability": "SERVICEABLE",
        "slaString": "25-30 mins",
        "lastMileTravelString": "4.6 km",
        "iconType": "ICON_TYPE_EMPTY"
      },
      "availability": {
        "nextCloseTime": "2026-01-31 02:00:00",
        "opened": true
      },
      "badges": {

      },
      "isOpen": true,
      "type": "F",
      "badgesV2": {
        "entityBadges": {
          "imageBased": {

          },
          "textBased": {

          },
          "textExtendedBadges": {

          }
        }
      },
      "aggregatedDiscountInfoV3": {
        "header": "ITEMS",
        "subHeader": "AT ₹78"
      },
      "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
          "lottie": {

          },
          "video": {

          }
        }
      },
      "reviewsSummary": {

      },
      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      "restaurantOfferPresentationInfo": {

      },
      "externalRatings": {
        "aggregatedRating": {
          "rating": "3.9",
          "ratingCount": "722"
        },
        "source": "GOOGLE",
        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
      },
      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
    },
    "analytics": {
      "context": "seo-data-667c4178-dcb5-482b-a3d1-7c54f6f8faca"
    },
    "cta": {
      "link": "https://www.swiggy.com/city/faridabad/la-pinoz-pizza-sector-15-rest56999",
      "type": "WEBLINK"
    }
  },
  {
    "info": {
      "id": "170934",
      "name": "Wow! Momo",
      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/6/30/438fb10c-ecd8-4272-b4ca-0ad5050f4674_170934.jpg",
      "locality": "Sector 15",
      "areaName": "Sector 15",
      "costForTwo": "₹300 for two",
      "cuisines": [
        "Momos",
        "Chinese",
        "fastfood",
        "Asian",
        "Beverages"
      ],
      "avgRating": 4.1,
      "parentId": "1776",
      "avgRatingString": "4.1",
      "totalRatingsString": "2.7K+",
      "sla": {
        "deliveryTime": 24,
        "lastMileTravel": 4.3,
        "serviceability": "SERVICEABLE",
        "slaString": "20-25 mins",
        "lastMileTravelString": "4.3 km",
        "iconType": "ICON_TYPE_EMPTY"
      },
      "availability": {
        "nextCloseTime": "2026-01-31 03:00:00",
        "opened": true
      },
      "badges": {
        "imageBadges": [
          {
            "imageId": "Rxawards/_CATEGORY-Chinese.png",
            "description": "Delivery!"
          },
          {
            "imageId": "Ratnesh_Badges/Rx_Awards_2025/Momo.png",
            "description": "Delivery!"
          }
        ]
      },
      "isOpen": true,
      "type": "F",
      "badgesV2": {
        "entityBadges": {
          "imageBased": {
            "badgeObject": [
              {
                "attributes": {
                  "description": "Delivery!",
                  "imageId": "Rxawards/_CATEGORY-Chinese.png"
                }
              },
              {
                "attributes": {
                  "description": "Delivery!",
                  "imageId": "Ratnesh_Badges/Rx_Awards_2025/Momo.png"
                }
              }
            ]
          },
          "textBased": {

          },
          "textExtendedBadges": {

          }
        }
      },
      "aggregatedDiscountInfoV3": {
        "header": "ITEMS",
        "subHeader": "AT ₹69"
      },
      "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
          "lottie": {

          },
          "video": {

          }
        }
      },
      "reviewsSummary": {

      },
      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      "restaurantOfferPresentationInfo": {

      },
      "externalRatings": {
        "aggregatedRating": {
          "rating": "4.7",
          "ratingCount": "160"
        },
        "source": "GOOGLE",
        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
      },
      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
    },
    "analytics": {
      "context": "seo-data-667c4178-dcb5-482b-a3d1-7c54f6f8faca"
    },
    "cta": {
      "link": "https://www.swiggy.com/city/faridabad/wow-momo-sector-15-rest170934",
      "type": "WEBLINK"
    }
  },
  {
    "info": {
      "id": "327587",
      "name": "Delights by INOX",
      "cloudinaryImageId": "b857fcf611707fedd3773eb02688f925",
      "locality": "Ef3 Mall",
      "areaName": "Sector 20",
      "costForTwo": "₹400 for two",
      "cuisines": [
        "Snacks"
      ],
      "avgRating": 3.7,
      "parentId": "385095",
      "avgRatingString": "3.7",
      "totalRatingsString": "28",
      "sla": {
        "deliveryTime": 23,
        "lastMileTravel": 0.2,
        "serviceability": "SERVICEABLE",
        "slaString": "20-25 mins",
        "lastMileTravelString": "0.2 km",
        "iconType": "ICON_TYPE_EMPTY"
      },
      "availability": {
        "nextCloseTime": "2026-01-30 23:57:00",
        "opened": true
      },
      "badges": {

      },
      "isOpen": true,
      "type": "F",
      "badgesV2": {
        "entityBadges": {
          "imageBased": {

          },
          "textBased": {

          },
          "textExtendedBadges": {

          }
        }
      },
      "aggregatedDiscountInfoV3": {
        "header": "60% OFF",
        "subHeader": "UPTO ₹120"
      },
      "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
          "lottie": {

          },
          "video": {

          }
        }
      },
      "reviewsSummary": {

      },
      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      "restaurantOfferPresentationInfo": {

      },
      "externalRatings": {
        "aggregatedRating": {
          "rating": "--"
        }
      },
      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
    },
    "analytics": {
      "context": "seo-data-667c4178-dcb5-482b-a3d1-7c54f6f8faca"
    },
    "cta": {
      "link": "https://www.swiggy.com/city/faridabad/delights-by-inox-ef3-mall-sector-20-rest327587",
      "type": "WEBLINK"
    }
  },
  {
    "info": {
      "id": "792013",
      "name": "Karigari - By Chef Harpal Singh Sokhi",
      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/9/24/7a1fba10-29d0-4740-9d43-c9e027037c5d_792013.jpg",
      "locality": "Bata Chowk Metro Station",
      "areaName": "Sector 16_FBD",
      "costForTwo": "₹800 for two",
      "cuisines": [
        "North Indian",
        "kebabs",
        "Biryani",
        "Mughlai"
      ],
      "avgRating": 4.3,
      "parentId": "527617",
      "avgRatingString": "4.3",
      "totalRatingsString": "893",
      "sla": {
        "deliveryTime": 28,
        "lastMileTravel": 2.9,
        "serviceability": "SERVICEABLE",
        "slaString": "25-30 mins",
        "lastMileTravelString": "2.9 km",
        "iconType": "ICON_TYPE_EMPTY"
      },
      "availability": {
        "nextCloseTime": "2026-01-30 23:30:00",
        "opened": true
      },
      "badges": {
        "imageBadges": [
          {
            "imageId": "newg.png",
            "description": "Gourmet"
          }
        ]
      },
      "isOpen": true,
      "type": "F",
      "badgesV2": {
        "entityBadges": {
          "imageBased": {
            "badgeObject": [
              {
                "attributes": {
                  "description": "Gourmet",
                  "imageId": "newg.png"
                }
              }
            ]
          },
          "textBased": {

          },
          "textExtendedBadges": {

          }
        }
      },
      "aggregatedDiscountInfoV3": {
        "header": "ITEMS",
        "subHeader": "AT ₹149"
      },
      "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
          "lottie": {

          },
          "video": {

          }
        }
      },
      "reviewsSummary": {

      },
      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      "restaurantOfferPresentationInfo": {

      },
      "externalRatings": {
        "aggregatedRating": {
          "rating": "--"
        }
      },
      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
    },
    "analytics": {
      "context": "seo-data-667c4178-dcb5-482b-a3d1-7c54f6f8faca"
    },
    "cta": {
      "link": "https://www.swiggy.com/city/faridabad/karigari-by-chef-harpal-singh-sokhi-bata-chowk-metro-station-sector-16-fbd-rest792013",
      "type": "WEBLINK"
    }
  },
  {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
    info: {
      id: "608594",
      name: "Pizza Hut",
      cloudinaryImageId:
        "RX_THUMBNAIL/IMAGES/VENDOR/2025/9/1/961a4640-ad96-464d-99a5-13430add9f98_608594.JPG",
      locality: "Sector 15A",
      areaName: "Sector 15A",
      costForTwo: "₹350 for two",
      cuisines: ["Pizzas"],
      avgRating: 4.3,
      parentId: "721",
      avgRatingString: "4.3",
      totalRatingsString: "1.5K+",
      sla: {
        deliveryTime: 44,
        lastMileTravel: 3,
        serviceability: "SERVICEABLE",
        slaString: "40-45 mins",
        lastMileTravelString: "3.0 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2025-11-25 03:45:00",
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {},
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "ITEMS",
        subHeader: "AT ₹99",
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "2.0K+",
        },
        source: "GOOGLE",
        sourceIconImageId: "v1704440323/google_ratings/rating_google_tag",
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b",
    },
    cta: {
      link: "https://www.swiggy.com/city/faridabad/pizza-hut-sector-15a-rest608594",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
    info: {
      id: "736173",
      name: "Olio - The Wood Fired Pizzeria",
      cloudinaryImageId:
        "RX_THUMBNAIL/IMAGES/VENDOR/2025/11/24/90630573-6cc3-4161-a5f2-41ad6396db70_736173.JPG",
      locality: "Neelam Bata Chowk",
      areaName: "Sector 31",
      costForTwo: "₹300 for two",
      cuisines: [
        "Pizzas",
        "Pastas",
        "Italian",
        "Fast Food",
        "Snacks",
        "Beverages",
        "Desserts",
      ],
      avgRating: 4.2,
      parentId: "11633",
      avgRatingString: "4.2",
      totalRatingsString: "1.9K+",
      sla: {
        deliveryTime: 52,
        lastMileTravel: 8.4,
        serviceability: "SERVICEABLE",
        slaString: "50-60 mins",
        lastMileTravelString: "8.4 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2025-11-25 05:30:00",
        opened: true,
      },
      badges: {
        imageBadges: [
          {
            imageId: "newg.png",
            description: "Gourmet",
          },
        ],
      },
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {
            badgeObject: [
              {
                attributes: {
                  description: "Gourmet",
                  imageId: "newg.png",
                },
              },
            ],
          },
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "ITEMS",
        subHeader: "AT ₹119",
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b",
    },
    cta: {
      link: "https://www.swiggy.com/city/faridabad/olio-the-wood-fired-pizzeria-neelam-bata-chowk-sector-31-rest736173",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
    info: {
      id: "76444",
      name: "Rama Bhojnalaya (Original since 1975)",
      cloudinaryImageId: "nwmu8u0ngvsr8tkibjx8",
      locality: "Sector 7",
      areaName: "Sector 7",
      costForTwo: "₹250 for two",
      cuisines: ["North Indian", "Indian"],
      avgRating: 4.2,
      veg: true,
      parentId: "15727",
      avgRatingString: "4.2",
      totalRatingsString: "10K+",
      sla: {
        deliveryTime: 33,
        lastMileTravel: 6.3,
        serviceability: "SERVICEABLE",
        slaString: "30-35 mins",
        lastMileTravelString: "6.3 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2025-11-24 23:00:00",
        opened: true,
      },
      badges: {
        imageBadges: [
          {
            imageId: "v1695133679/badges/Pure_Veg111.png",
            description: "pureveg",
          },
        ],
      },
      isOpen: true,
      aggregatedDiscountInfoV2: {},
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {
            badgeObject: [
              {
                attributes: {
                  description: "pureveg",
                  imageId: "v1695133679/badges/Pure_Veg111.png",
                },
              },
            ],
          },
          textBased: {},
          textExtendedBadges: {},
        },
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "1.5K+",
        },
        source: "GOOGLE",
        sourceIconImageId: "v1704440323/google_ratings/rating_google_tag",
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b",
    },
    cta: {
      link: "https://www.swiggy.com/city/faridabad/rama-bhojnalaya-original-since-1975-sector-7-rest76444",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
    info: {
      id: "483339",
      name: "ZAZA Mughal Biryani",
      cloudinaryImageId:
        "RX_THUMBNAIL/IMAGES/VENDOR/2024/9/17/7ecf81cb-2ef7-4ada-92d6-61ec8e6c8653_483339.jpg",
      locality: "Kc Road",
      areaName: "Badkal Lake",
      costForTwo: "₹250 for two",
      cuisines: ["Biryani", "North Indian", "Awadhi"],
      avgRating: 4.5,
      parentId: "22473",
      avgRatingString: "4.5",
      totalRatingsString: "717",
      sla: {
        deliveryTime: 25,
        lastMileTravel: 4.5,
        serviceability: "SERVICEABLE",
        slaString: "20-30 mins",
        lastMileTravelString: "4.5 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2025-11-25 02:00:00",
        opened: true,
      },
      badges: {
        imageBadges: [
          {
            imageId: "Rxawards/_CATEGORY-Biryani.png",
            description: "Delivery!",
          },
        ],
      },
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {
            badgeObject: [
              {
                attributes: {
                  description: "Delivery!",
                  imageId: "Rxawards/_CATEGORY-Biryani.png",
                },
              },
            ],
          },
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "ITEMS",
        subHeader: "AT ₹99",
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b",
    },
    cta: {
      link: "https://www.swiggy.com/city/faridabad/zaza-mughal-biryani-kc-road-badkal-lake-rest483339",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
    info: {
      id: "681599",
      name: "LeanCrust Pizza- ThinCrust Experts",
      cloudinaryImageId:
        "RX_THUMBNAIL/IMAGES/VENDOR/2024/8/30/d97ea843-7c81-4362-a9a9-d55a7054c09c_681599.jpg",
      locality: "K C Road",
      areaName: "New Industrial Township",
      costForTwo: "₹300 for two",
      cuisines: ["Pizzas", "Italian", "Desserts"],
      avgRating: 4.7,
      parentId: "11216",
      avgRatingString: "4.7",
      totalRatingsString: "803",
      sla: {
        deliveryTime: 25,
        lastMileTravel: 4.5,
        serviceability: "SERVICEABLE",
        slaString: "20-30 mins",
        lastMileTravelString: "4.5 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2025-11-25 02:00:00",
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {},
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "ITEMS",
        subHeader: "AT ₹99",
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b",
    },
    cta: {
      link: "https://www.swiggy.com/city/faridabad/leancrust-pizza-thincrust-experts-k-c-road-new-industrial-township-rest681599",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
    info: {
      id: "1151985",
      name: "Zulu's Pizza - Fresh Fanatics",
      cloudinaryImageId:
        "RX_THUMBNAIL/IMAGES/VENDOR/2025/7/21/65c93065-98a7-4c77-8141-a7fc3f8e063d_1151985.JPG",
      locality: "KC Road",
      areaName: "Badkal Lake",
      costForTwo: "₹200 for two",
      cuisines: ["Pizzas", "Italian", "Fast Food", "Desserts", "Beverages"],
      avgRating: 4.6,
      parentId: "661655",
      avgRatingString: "4.6",
      totalRatingsString: "17",
      sla: {
        deliveryTime: 25,
        lastMileTravel: 4.5,
        serviceability: "SERVICEABLE",
        slaString: "20-30 mins",
        lastMileTravelString: "4.5 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2025-11-25 02:00:00",
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {},
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "ITEMS",
        subHeader: "AT ₹99",
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      isNewlyOnboarded: true,
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b",
    },
    cta: {
      link: "https://www.swiggy.com/city/faridabad/zulus-pizza-fresh-fanatics-kc-road-badkal-lake-rest1151985",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
    info: {
      id: "643819",
      name: "WeFit - Protein Bowls, Salads & Sandwiches",
      cloudinaryImageId:
        "RX_THUMBNAIL/IMAGES/VENDOR/2025/2/3/ade3c596-ac60-46ce-8c9f-a0cd3fa4e402_643819.jpg",
      locality: "K C Road",
      areaName: "NIT_FBD",
      costForTwo: "₹250 for two",
      cuisines: ["Healthy Food", "Salads", "Keto", "Snacks"],
      avgRating: 4.7,
      parentId: "355285",
      avgRatingString: "4.7",
      totalRatingsString: "866",
      sla: {
        deliveryTime: 25,
        lastMileTravel: 4.5,
        serviceability: "SERVICEABLE",
        slaString: "20-30 mins",
        lastMileTravelString: "4.5 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2025-11-25 02:00:00",
        opened: true,
      },
      badges: {
        imageBadges: [
          {
            imageId: "High%20Protein/rx%20tag%205.png",
            description: "High Protein",
          },
        ],
      },
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {
            badgeObject: [
              {
                attributes: {
                  description: "High Protein",
                  imageId: "High%20Protein/rx%20tag%205.png",
                },
              },
            ],
          },
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "ITEMS",
        subHeader: "AT ₹149",
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b",
    },
    cta: {
      link: "https://www.swiggy.com/city/faridabad/wefit-protein-bowls-salads-and-sandwiches-k-c-road-nit-fbd-rest643819",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
    info: {
      id: "1219428",
      name: "Salad Days",
      cloudinaryImageId:
        "RX_THUMBNAIL/IMAGES/VENDOR/2025/10/8/d39cf270-961f-4f3a-bb8f-dfca91db02ce_1219428.jpg",
      locality: "Post Office",
      areaName: "Sector 16_FBD",
      costForTwo: "₹500 for two",
      cuisines: ["Salads"],
      avgRating: 4.7,
      parentId: "796",
      avgRatingString: "4.7",
      totalRatingsString: "71",
      sla: {
        deliveryTime: 34,
        lastMileTravel: 4.2,
        serviceability: "SERVICEABLE",
        slaString: "30-35 mins",
        lastMileTravelString: "4.2 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2025-11-24 23:59:00",
        opened: true,
      },
      badges: {
        imageBadges: [
          {
            imageId: "High%20Protein/rx%20tag%205.png",
            description: "High Protein",
          },
          {
            imageId: "newg.png",
            description: "Gourmet",
          },
        ],
      },
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {
            badgeObject: [
              {
                attributes: {
                  description: "High Protein",
                  imageId: "High%20Protein/rx%20tag%205.png",
                },
              },
              {
                attributes: {
                  description: "Gourmet",
                  imageId: "newg.png",
                },
              },
            ],
          },
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "40% OFF",
        subHeader: "UPTO ₹80",
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      isNewlyOnboarded: true,
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b",
    },
    cta: {
      link: "https://www.swiggy.com/city/faridabad/salad-days-post-office-sector-16-fbd-rest1219428",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
    info: {
      id: "608600",
      name: "Pizza Hut",
      cloudinaryImageId:
        "RX_THUMBNAIL/IMAGES/VENDOR/2025/9/1/961a4640-ad96-464d-99a5-13430add9f98_608594.JPG",
      locality: "Sector 15A",
      areaName: "Sector 15A",
      costForTwo: "₹350 for two",
      cuisines: ["Pizzas"],
      avgRating: 4.3,
      parentId: "721",
      avgRatingString: "4.3",
      totalRatingsString: "1.5K+",
      sla: {
        deliveryTime: 44,
        lastMileTravel: 3,
        serviceability: "SERVICEABLE",
        slaString: "40-45 mins",
        lastMileTravelString: "3.0 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2025-11-25 03:45:00",
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {},
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "ITEMS",
        subHeader: "AT ₹99",
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "2.0K+",
        },
        source: "GOOGLE",
        sourceIconImageId: "v1704440323/google_ratings/rating_google_tag",
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b",
    },
    cta: {
      link: "https://www.swiggy.com/city/faridabad/pizza-hut-sector-15a-rest608594",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
    info: {
      id: "736180",
      name: "Olio - The Wood Fired Pizzeria",
      cloudinaryImageId:
        "RX_THUMBNAIL/IMAGES/VENDOR/2025/11/24/90630573-6cc3-4161-a5f2-41ad6396db70_736173.JPG",
      locality: "Neelam Bata Chowk",
      areaName: "Sector 31",
      costForTwo: "₹300 for two",
      cuisines: [
        "Pizzas",
        "Pastas",
        "Italian",
        "Fast Food",
        "Snacks",
        "Beverages",
        "Desserts",
      ],
      avgRating: 4.2,
      parentId: "11633",
      avgRatingString: "4.2",
      totalRatingsString: "1.9K+",
      sla: {
        deliveryTime: 52,
        lastMileTravel: 8.4,
        serviceability: "SERVICEABLE",
        slaString: "50-60 mins",
        lastMileTravelString: "8.4 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2025-11-25 05:30:00",
        opened: true,
      },
      badges: {
        imageBadges: [
          {
            imageId: "newg.png",
            description: "Gourmet",
          },
        ],
      },
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {
            badgeObject: [
              {
                attributes: {
                  description: "Gourmet",
                  imageId: "newg.png",
                },
              },
            ],
          },
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "ITEMS",
        subHeader: "AT ₹119",
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b",
    },
    cta: {
      link: "https://www.swiggy.com/city/faridabad/olio-the-wood-fired-pizzeria-neelam-bata-chowk-sector-31-rest736173",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
    info: {
      id: "764785678",
      name: "Rama Bhojnalaya (Original since 1975)",
      cloudinaryImageId: "nwmu8u0ngvsr8tkibjx8",
      locality: "Sector 7",
      areaName: "Sector 7",
      costForTwo: "₹250 for two",
      cuisines: ["North Indian", "Indian"],
      avgRating: 4.2,
      veg: true,
      parentId: "15727",
      avgRatingString: "4.2",
      totalRatingsString: "10K+",
      sla: {
        deliveryTime: 33,
        lastMileTravel: 6.3,
        serviceability: "SERVICEABLE",
        slaString: "30-35 mins",
        lastMileTravelString: "6.3 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2025-11-24 23:00:00",
        opened: true,
      },
      badges: {
        imageBadges: [
          {
            imageId: "v1695133679/badges/Pure_Veg111.png",
            description: "pureveg",
          },
        ],
      },
      isOpen: true,
      aggregatedDiscountInfoV2: {},
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {
            badgeObject: [
              {
                attributes: {
                  description: "pureveg",
                  imageId: "v1695133679/badges/Pure_Veg111.png",
                },
              },
            ],
          },
          textBased: {},
          textExtendedBadges: {},
        },
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "1.5K+",
        },
        source: "GOOGLE",
        sourceIconImageId: "v1704440323/google_ratings/rating_google_tag",
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b",
    },
    cta: {
      link: "https://www.swiggy.com/city/faridabad/rama-bhojnalaya-original-since-1975-sector-7-rest76444",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
    info: {
      id: "48336789",
      name: "ZAZA Mughal Biryani",
      cloudinaryImageId:
        "RX_THUMBNAIL/IMAGES/VENDOR/2024/9/17/7ecf81cb-2ef7-4ada-92d6-61ec8e6c8653_483339.jpg",
      locality: "Kc Road",
      areaName: "Badkal Lake",
      costForTwo: "₹250 for two",
      cuisines: ["Biryani", "North Indian", "Awadhi"],
      avgRating: 4.5,
      parentId: "22473",
      avgRatingString: "4.5",
      totalRatingsString: "717",
      sla: {
        deliveryTime: 25,
        lastMileTravel: 4.5,
        serviceability: "SERVICEABLE",
        slaString: "20-30 mins",
        lastMileTravelString: "4.5 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2025-11-25 02:00:00",
        opened: true,
      },
      badges: {
        imageBadges: [
          {
            imageId: "Rxawards/_CATEGORY-Biryani.png",
            description: "Delivery!",
          },
        ],
      },
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {
            badgeObject: [
              {
                attributes: {
                  description: "Delivery!",
                  imageId: "Rxawards/_CATEGORY-Biryani.png",
                },
              },
            ],
          },
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "ITEMS",
        subHeader: "AT ₹99",
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b",
    },
    cta: {
      link: "https://www.swiggy.com/city/faridabad/zaza-mughal-biryani-kc-road-badkal-lake-rest483339",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
    info: {
      id: "681467",
      name: "LeanCrust Pizza- ThinCrust Experts",
      cloudinaryImageId:
        "RX_THUMBNAIL/IMAGES/VENDOR/2024/8/30/d97ea843-7c81-4362-a9a9-d55a7054c09c_681599.jpg",
      locality: "K C Road",
      areaName: "New Industrial Township",
      costForTwo: "₹300 for two",
      cuisines: ["Pizzas", "Italian", "Desserts"],
      avgRating: 4.7,
      parentId: "11216",
      avgRatingString: "4.7",
      totalRatingsString: "803",
      sla: {
        deliveryTime: 25,
        lastMileTravel: 4.5,
        serviceability: "SERVICEABLE",
        slaString: "20-30 mins",
        lastMileTravelString: "4.5 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2025-11-25 02:00:00",
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {},
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "ITEMS",
        subHeader: "AT ₹99",
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b",
    },
    cta: {
      link: "https://www.swiggy.com/city/faridabad/leancrust-pizza-thincrust-experts-k-c-road-new-industrial-township-rest681599",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
    info: {
      id: "1151345",
      name: "Zulu's Pizza - Fresh Fanatics",
      cloudinaryImageId:
        "RX_THUMBNAIL/IMAGES/VENDOR/2025/7/21/65c93065-98a7-4c77-8141-a7fc3f8e063d_1151985.JPG",
      locality: "KC Road",
      areaName: "Badkal Lake",
      costForTwo: "₹200 for two",
      cuisines: ["Pizzas", "Italian", "Fast Food", "Desserts", "Beverages"],
      avgRating: 4.6,
      parentId: "661655",
      avgRatingString: "4.6",
      totalRatingsString: "17",
      sla: {
        deliveryTime: 25,
        lastMileTravel: 4.5,
        serviceability: "SERVICEABLE",
        slaString: "20-30 mins",
        lastMileTravelString: "4.5 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2025-11-25 02:00:00",
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {},
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "ITEMS",
        subHeader: "AT ₹99",
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      isNewlyOnboarded: true,
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b",
    },
    cta: {
      link: "https://www.swiggy.com/city/faridabad/zulus-pizza-fresh-fanatics-kc-road-badkal-lake-rest1151985",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
    info: {
      id: "6435679",
      name: "WeFit - Protein Bowls, Salads & Sandwiches",
      cloudinaryImageId:
        "RX_THUMBNAIL/IMAGES/VENDOR/2025/2/3/ade3c596-ac60-46ce-8c9f-a0cd3fa4e402_643819.jpg",
      locality: "K C Road",
      areaName: "NIT_FBD",
      costForTwo: "₹250 for two",
      cuisines: ["Healthy Food", "Salads", "Keto", "Snacks"],
      avgRating: 4.7,
      parentId: "355285",
      avgRatingString: "4.7",
      totalRatingsString: "866",
      sla: {
        deliveryTime: 25,
        lastMileTravel: 4.5,
        serviceability: "SERVICEABLE",
        slaString: "20-30 mins",
        lastMileTravelString: "4.5 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2025-11-25 02:00:00",
        opened: true,
      },
      badges: {
        imageBadges: [
          {
            imageId: "High%20Protein/rx%20tag%205.png",
            description: "High Protein",
          },
        ],
      },
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {
            badgeObject: [
              {
                attributes: {
                  description: "High Protein",
                  imageId: "High%20Protein/rx%20tag%205.png",
                },
              },
            ],
          },
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "ITEMS",
        subHeader: "AT ₹149",
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b",
    },
    cta: {
      link: "https://www.swiggy.com/city/faridabad/wefit-protein-bowls-salads-and-sandwiches-k-c-road-nit-fbd-rest643819",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
    info: {
      id: "121990244",
      name: "Salad Days",
      cloudinaryImageId:
        "RX_THUMBNAIL/IMAGES/VENDOR/2025/10/8/d39cf270-961f-4f3a-bb8f-dfca91db02ce_1219428.jpg",
      locality: "Post Office",
      areaName: "Sector 16_FBD",
      costForTwo: "₹500 for two",
      cuisines: ["Salads"],
      avgRating: 4.7,
      parentId: "796",
      avgRatingString: "4.7",
      totalRatingsString: "71",
      sla: {
        deliveryTime: 34,
        lastMileTravel: 4.2,
        serviceability: "SERVICEABLE",
        slaString: "30-35 mins",
        lastMileTravelString: "4.2 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2025-11-24 23:59:00",
        opened: true,
      },
      badges: {
        imageBadges: [
          {
            imageId: "High%20Protein/rx%20tag%205.png",
            description: "High Protein",
          },
          {
            imageId: "newg.png",
            description: "Gourmet",
          },
        ],
      },
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {
            badgeObject: [
              {
                attributes: {
                  description: "High Protein",
                  imageId: "High%20Protein/rx%20tag%205.png",
                },
              },
              {
                attributes: {
                  description: "Gourmet",
                  imageId: "newg.png",
                },
              },
            ],
          },
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "40% OFF",
        subHeader: "UPTO ₹80",
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      isNewlyOnboarded: true,
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b",
    },
    cta: {
      link: "https://www.swiggy.com/city/faridabad/salad-days-post-office-sector-16-fbd-rest1219428",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
];

export const menuData = {
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "425",
              "name": "Hotel Empire",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "hotel-empire-5th-block-koramangala",
                "city": "bangalore"
              },
              "uniqueId": "79848f6e-cd46-4b74-b127-d1fc3af3256c",
              "cloudinaryImageId": "un4omn7rcunkmlw6vikr",
              "locality": "Koramangala",
              "areaName": "Koramangala",
              "costForTwo": "45000",
              "costForTwoMessage": "₹450 for two",
              "cuisines": ["North Indian", "Kebabs"],
              "avgRating": 4.1,
              "feeDetails": {
                "restaurantId": "425",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 3300
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 3300,
                "title": "Delivery Charge",
                "amount": "3300"
              },
              "parentId": "475",
              "avgRatingString": "4.1",
              "totalRatingsString": "10K+ ratings",
              "sla": {
                "restaurantId": "425",
                "deliveryTime": 22,
                "minDeliveryTime": 22,
                "maxDeliveryTime": 22,
                "lastMileTravel": 1.3,
                "serviceability": "SERVICEABLE",
                "stressFactor": 0.736653,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 1,
                "slaString": "22 MINS",
                "lastMileTravelString": "1.2 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2023-07-30 05:00:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {}
              },
              "aggregatedDiscountInfo": {
                "header": "10% off",
                "shortDescriptionList": [
                  {
                    "meta": "10% off | Use TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "10% off | Use PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "10% off up to ₹40 | Use code TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "10% off | Use code PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {},
              "slugString": "hotel-empire-5th-block-koramangala",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "103, Industrial Area, 5th Block, Near Jyothi Nivas College, Koramangala 5th Block, Bangalore"
                },
                {
                  "title": "Cuisines",
                  "message": "North Indian,Kebabs"
                }
              ],
              "totalRatings": 10000,
              "aggregatedDiscountInfoV2": {
                "header": "10% off",
                "shortDescriptionList": [
                  {
                    "meta": "10% off | Use TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "10% off | Use PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "10% off up to ₹40 | Use code TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "10% off | Use code PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "minValue": 350,
                  "maxValue": 500,
                  "priority": 2,
                  "couponCode": "PARTY",
                  "discountInfo": {
                    "discountType": "Percentage",
                    "value": 10
                  },
                  "lockedMessage": "Add items worth ₹<amount> to unlock flat 10% off | Code PARTY",
                  "unlockedMessage": "PARTY Coupon Unlocked! Use it to save flat 10% off",
                  "logoCtx": {}
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/425"
              },
              "expectationNotifiers": [
                {
                  "icon": {},
                  "popup": {
                    "cta": {}
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {}
                  }
                }
              ],
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {}
                    },
                    "linkCta": {}
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {},
                "presentation": {}
              },
              "latLong": "12.934816,77.61580500000002"
            },
            "analytics": {}
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 4,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {},
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {}
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "10% OFF UPTO ₹40",
                      "offerTagColor": "#E46D47",
                      "offerIds": ["65d416bb-4aa9-49cd-9c8b-241f30b30484"],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE TRYNEW",
                      "description": "ABOVE ₹159",
                      "offerType": "offers",
                      "restId": "425",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT 10% OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": ["6e9bcb18-a206-46d8-a9c7-268b855d1273"],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE PARTY",
                      "description": "ABOVE ₹500",
                      "offerType": "offers",
                      "restId": "425",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "30% OFF UPTO ₹75",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
                      "offerIds": ["e914d8fd-1192-49a8-97c9-24e29cd698e4"],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹199",
                      "offerType": "offers",
                      "restId": "425",
                      "offerLogo": "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹300",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "offerIds": ["ab6ca12d-e322-409c-8396-4b287bdeaf02"],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CITIFOODIE",
                      "description": "ABOVE ₹1200",
                      "offerType": "offers",
                      "restId": "425",
                      "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ]
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {},
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {}
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65669680",
                              "name": "Bucket Chicken Biriyani",
                              "category": "Bucket Biriyani",
                              "description": "Serves 7",
                              "imageId": "o3md7bihfchbxxrcfbgu",
                              "inStock": 1,
                              "price": 126000,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "68924013",
                                  "groupName": "Egg",
                                  "choices": [
                                    {
                                      "id": "54935061",
                                      "name": "Boiled Egg",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842130",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842149",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842126",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842122",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842154",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "54156512",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842158",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 7"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "49 ratings",
                                  "ratingCountV2": "49"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65669684",
                              "name": "Bucket Biriyani With Chicken Kabab",
                              "category": "Bucket Biriyani",
                              "description": "Serves 7",
                              "imageId": "ivjkz6qcirckeynmccj1",
                              "inStock": 1,
                              "price": 157500,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "68924037",
                                  "groupName": "Egg",
                                  "choices": [
                                    {
                                      "id": "54935061",
                                      "name": "Boiled Egg",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842345",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842369",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842342",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842338",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842390",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "54156512",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842393",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 7"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65669685",
                              "name": "Bucket Biriyani With Fiery Wings",
                              "category": "Bucket Biriyani",
                              "description": "Serves 7",
                              "imageId": "qvnrbktvk7whi0qzcoau",
                              "inStock": 1,
                              "price": 163100,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "68924045",
                                  "groupName": "Egg",
                                  "choices": [
                                    {
                                      "id": "54935061",
                                      "name": "Boiled Egg",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842447",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842459",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842443",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842440",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842472",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "54156512",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842475",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 7"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65669686",
                              "name": "Bucket Biriyani With Kalmi Kabab",
                              "category": "Bucket Biriyani",
                              "description": "Serves 7",
                              "imageId": "kmz6vppi99urueddhba4",
                              "inStock": 1,
                              "price": 167000,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "68924051",
                                  "groupName": "Egg",
                                  "choices": [
                                    {
                                      "id": "54935061",
                                      "name": "Boiled Egg",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842505",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842545",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842499",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842495",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842562",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "54156512",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842565",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 7"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822532",
                              "name": "Empire Special Chilly Kebab",
                              "category": "Empire Special Chicken (Dry)",
                              "description": "Serves 1",
                              "imageId": "mwjxnsys86a5apetncxm",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810824",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 420,
                                        "id": "18813851",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 215,
                                        "id": "18813850",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 125,
                                        "default": 1,
                                        "id": "18813849",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810824",
                                        "variationId": "18813851"
                                      }
                                    ],
                                    "price": 42000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835949",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835949",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835949",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835944",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835944",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835944",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810824",
                                        "variationId": "18813850"
                                      }
                                    ],
                                    "price": 21500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835949",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835949",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835949",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835944",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835944",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835944",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810824",
                                        "variationId": "18813849"
                                      }
                                    ],
                                    "price": 12500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835949",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835949",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835949",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835944",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835944",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835944",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67835949",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835953",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835944",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835960",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 12500,
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "405 ratings",
                                  "ratingCountV2": "405"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "4300494",
                              "name": "Popcorn Chicken Kebab",
                              "category": "Empire Special Chicken (Dry)",
                              "description": "Serves 1",
                              "imageId": "irvoj3hrrcsu5t5n3wx8",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810784",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 490,
                                        "id": "18813738",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 255,
                                        "id": "18813737",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 137,
                                        "default": 1,
                                        "id": "18813736",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810784",
                                        "variationId": "18813738"
                                      }
                                    ],
                                    "price": 49000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835113",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835113",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835113",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835111",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835111",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835111",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810784",
                                        "variationId": "18813737"
                                      }
                                    ],
                                    "price": 25500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835113",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835113",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835113",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835111",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835111",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835111",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810784",
                                        "variationId": "18813736"
                                      }
                                    ],
                                    "price": 13700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835113",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835113",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835113",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835111",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835111",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835111",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67835113",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835120",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835111",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835125",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 13700,
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "859 ratings",
                                  "ratingCountV2": "859"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215037",
                              "name": "Grilled Chicken",
                              "category": "Empire Special Chicken (Dry)",
                              "description": "Serves 1",
                              "imageId": "wyxryeipwcmz4q6hen2h",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810794",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 420,
                                        "id": "18813765",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 214,
                                        "default": 1,
                                        "id": "18813764",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810794",
                                        "variationId": "18813765"
                                      }
                                    ],
                                    "price": 42000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835557",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835557",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835557",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835542",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835542",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835542",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835580",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835580",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835580",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835580",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835580",
                                        "addonId": "54156429"
                                      },
                                      {
                                        "groupId": "67866479",
                                        "addonId": "54168863"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810794",
                                        "variationId": "18813764"
                                      }
                                    ],
                                    "price": 21400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835557",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835557",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835557",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835542",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835542",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835542",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835580",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835580",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835580",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835580",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835580",
                                        "addonId": "54156429"
                                      },
                                      {
                                        "groupId": "67866479",
                                        "addonId": "54168863"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67835557",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835568",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835542",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835580",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67866479",
                                  "groupName": "Bread",
                                  "choices": [
                                    {
                                      "id": "54168863",
                                      "name": "Kuboos",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 21400,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "9402 ratings",
                                  "ratingCountV2": "9402"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822505",
                              "name": "Empire Special Chicken Kebab",
                              "category": "Empire Special Chicken (Dry)",
                              "description": "Serves 1",
                              "imageId": "obqi7kmdulkmoyrbbx1g",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810800",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 377,
                                        "id": "18813783",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 194,
                                        "id": "18813782",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 107,
                                        "default": 1,
                                        "id": "18813781",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810800",
                                        "variationId": "18813783"
                                      }
                                    ],
                                    "price": 37700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835673",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835673",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835673",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835670",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835670",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835670",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810800",
                                        "variationId": "18813782"
                                      }
                                    ],
                                    "price": 19400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835673",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835673",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835673",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835670",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835670",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835670",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810800",
                                        "variationId": "18813781"
                                      }
                                    ],
                                    "price": 10700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835673",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835673",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835673",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835670",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835670",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835670",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67835673",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835677",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835670",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835696",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 10700,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "5116 ratings",
                                  "ratingCountV2": "5116"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215167",
                              "name": "Lemon Rice",
                              "category": "Rice",
                              "description": "Serves 1",
                              "imageId": "vgmmxxdnxv06pjgf3ksw",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "23808621",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 139,
                                        "default": 1,
                                        "id": "77096183",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 139,
                                        "id": "77096184",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808621",
                                        "variationId": "77096183"
                                      }
                                    ],
                                    "price": 13900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67841555",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67841555",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67841555",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67841551",
                                        "addonId": "17505976"
                                      },
                                      {
                                        "groupId": "67841551",
                                        "addonId": "54156510"
                                      },
                                      {
                                        "groupId": "67841593",
                                        "addonId": "54156512"
                                      },
                                      {
                                        "groupId": "67841598",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67841598",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67841598",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67841598",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67841598",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808621",
                                        "variationId": "77096184"
                                      }
                                    ],
                                    "price": 13900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67841555",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67841555",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67841555",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67841551",
                                        "addonId": "17505976"
                                      },
                                      {
                                        "groupId": "67841551",
                                        "addonId": "54156510"
                                      },
                                      {
                                        "groupId": "67841593",
                                        "addonId": "54156512"
                                      },
                                      {
                                        "groupId": "67841598",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67841598",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67841598",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67841598",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67841598",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67841561",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841578",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841555",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841551",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841593",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "54156512",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841598",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 13900,
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "309 ratings",
                                  "ratingCountV2": "309"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215110",
                              "name": "Chicken Tikka Masala",
                              "category": "Empire Special Chicken (Gravy)",
                              "description": "Serves 1",
                              "imageId": "icpycagtwmqflonmjud8",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810906",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 515,
                                        "id": "18814079",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 273,
                                        "id": "18814078",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 153,
                                        "default": 1,
                                        "id": "18814077",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810906",
                                        "variationId": "18814079"
                                      }
                                    ],
                                    "price": 51500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923857",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67839762",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67839762",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67839762",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810906",
                                        "variationId": "18814078"
                                      }
                                    ],
                                    "price": 27300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923857",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67839762",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67839762",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67839762",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810906",
                                        "variationId": "18814077"
                                      }
                                    ],
                                    "price": 15300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923857",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67839762",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67839762",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67839762",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923857",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839762",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839769",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839808",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 15300,
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "1070 ratings",
                                  "ratingCountV2": "1070"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822601",
                              "name": "Butter Chicken Boneless",
                              "category": "Empire Special Chicken (Gravy)",
                              "description": "Serves 1",
                              "imageId": "vbtgihmcmseeizl1iuma",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810875",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 500,
                                        "id": "18813991",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 265,
                                        "id": "18813990",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 153,
                                        "default": 1,
                                        "id": "18813989",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810875",
                                        "variationId": "18813991"
                                      }
                                    ],
                                    "price": 50000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923621",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67837898",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67837898",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67837898",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810875",
                                        "variationId": "18813990"
                                      }
                                    ],
                                    "price": 26500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923621",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67837898",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67837898",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67837898",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810875",
                                        "variationId": "18813989"
                                      }
                                    ],
                                    "price": 15300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923621",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67837898",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67837898",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67837898",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923621",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67837898",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67837909",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67837929",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 15300,
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "949 ratings",
                                  "ratingCountV2": "949"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822617",
                              "name": "Chicken Varval",
                              "category": "Empire Special Chicken (Gravy)",
                              "description": "Serves 1",
                              "imageId": "mk3acltmonkzutknsqny",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810887",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 480,
                                        "id": "18814025",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 255,
                                        "id": "18814024",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 143,
                                        "default": 1,
                                        "id": "18814023",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810887",
                                        "variationId": "18814025"
                                      }
                                    ],
                                    "price": 48000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923663",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67838418",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67838418",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67838418",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810887",
                                        "variationId": "18814024"
                                      }
                                    ],
                                    "price": 25500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923663",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67838418",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67838418",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67838418",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810887",
                                        "variationId": "18814023"
                                      }
                                    ],
                                    "price": 14300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923663",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67838418",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67838418",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67838418",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923663",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838418",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838427",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838446",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 14300,
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "258 ratings",
                                  "ratingCountV2": "258"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215186",
                              "name": "Ceylon Parotta",
                              "category": "Parottas",
                              "description": "Serves 1",
                              "imageId": "ediibdf3gsujqd6ifutq",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "23808578",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 37,
                                        "default": 1,
                                        "id": "77096099",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 37,
                                        "id": "77096100",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808578",
                                        "variationId": "77096099"
                                      }
                                    ],
                                    "price": 3700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67836374",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836374",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836374",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836374",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836374",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808578",
                                        "variationId": "77096100"
                                      }
                                    ],
                                    "price": 3700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67836374",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836374",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836374",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836374",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836374",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67836362",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836368",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836374",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 3700,
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "1017 ratings",
                                  "ratingCountV2": "1017"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215187",
                              "name": "Coin Parotta",
                              "category": "Parottas",
                              "description": "Serves 1",
                              "imageId": "fmfupmuieyd62gfdcddh",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "23808597",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 30,
                                        "default": 1,
                                        "id": "77096135",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 30,
                                        "id": "77096136",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808597",
                                        "variationId": "77096135"
                                      }
                                    ],
                                    "price": 3000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67838847",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838847",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838847",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838847",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838847",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808597",
                                        "variationId": "77096136"
                                      }
                                    ],
                                    "price": 3000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67838847",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838847",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838847",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838847",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838847",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67838789",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838811",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838847",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 3000,
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "1804 ratings",
                                  "ratingCountV2": "1804"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215175",
                              "name": "Kulcha",
                              "category": "Rotis",
                              "description": "Serves 1",
                              "imageId": "bzdjx3rqgccz6iuyyk0b",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "24090406",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 35,
                                        "default": 1,
                                        "id": "77727447",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 35,
                                        "id": "77727448",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "24090406",
                                        "variationId": "77727447"
                                      }
                                    ],
                                    "price": 3500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67839103",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839103",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839103",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839103",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839103",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "24090406",
                                        "variationId": "77727448"
                                      }
                                    ],
                                    "price": 3500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67839103",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839103",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839103",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839103",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839103",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67839052",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839089",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839103",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 3500,
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "1067 ratings",
                                  "ratingCountV2": "1067"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215089",
                              "name": "Dal Fry",
                              "category": "Veg Gravy",
                              "description": "Serves 1",
                              "imageId": "jxxtujwekfghedg6axk1",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810896",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 122,
                                        "id": "18814050",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 71,
                                        "default": 1,
                                        "id": "18814049",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810896",
                                        "variationId": "18814050"
                                      }
                                    ],
                                    "price": 12200,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923715",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67838709",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67838709",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67838709",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838750",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838750",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838750",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838750",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838750",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810896",
                                        "variationId": "18814049"
                                      }
                                    ],
                                    "price": 7100,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923715",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67838709",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67838709",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67838709",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838750",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838750",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838750",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838750",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838750",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923715",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838709",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838720",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838750",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 7100,
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "1319 ratings",
                                  "ratingCountV2": "1319"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215084",
                              "name": "Paneer Butter Masala",
                              "category": "Veg Gravy",
                              "description": "Serves 1",
                              "imageId": "aebk3ggsozr3gtijronv",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810851",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 189,
                                        "id": "18813925",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 112,
                                        "default": 1,
                                        "id": "18813924",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810851",
                                        "variationId": "18813925"
                                      }
                                    ],
                                    "price": 18900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923559",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67836806",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67836806",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67836806",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67836847",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836847",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836847",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836847",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836847",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810851",
                                        "variationId": "18813924"
                                      }
                                    ],
                                    "price": 11200,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923559",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67836806",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67836806",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67836806",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67836847",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836847",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836847",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836847",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836847",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923559",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836806",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836836",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836847",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 11200,
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "2157 ratings",
                                  "ratingCountV2": "2157"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "104035812",
                              "name": "Chocolate Mousse",
                              "category": "Juice Shop",
                              "description": "Serves 1",
                              "imageId": "rkufmtlhzq2ufiuqs5on",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7500,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "104035813",
                              "name": "Hot Chocolate Fudge",
                              "category": "Juice Shop",
                              "description": "Serves 1",
                              "imageId": "l6sxj0dmltdp1yaoeaym",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14500,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "28309444",
                              "name": "Death By Chocolate",
                              "category": "Juice Shop",
                              "description": "Serves 1 | DBC is everyone’s favourite. Scoops of rich and creamy vanilla ice cream with of a warm homemade chocolate cake sponge, drizzled with our signature homemade DBC sauce and roasted peanuts is an absolute treat for every dessert lover.",
                              "imageId": "lvhxynldslndyn4u02ma",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16500,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.1",
                                  "ratingCount": "42 ratings",
                                  "ratingCountV2": "42"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "96906011",
                              "name": "Avocado Thick Shake",
                              "category": "Juice Shop",
                              "description": "Serves 1",
                              "imageId": "pxyhxnyqzsqrfrddomo6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13500,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "100217612",
                              "name": "Matka Kulfi",
                              "category": "Juice Shop",
                              "description": "Serves 1",
                              "imageId": "knpo2manobuiagemdkib",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Biriyani",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822517",
                              "name": "Egg Biriyani",
                              "category": "Biriyani",
                              "description": "Serves 1",
                              "imageId": "estud4jfulsslglmzges",
                              "inStock": 1,
                              "price": 21400,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "68923986",
                                  "groupName": "Egg",
                                  "choices": [
                                    {
                                      "id": "54935061",
                                      "name": "Boiled Egg",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841797",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841860",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841791",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841790",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841929",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "54156512",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841944",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "137 ratings",
                                  "ratingCountV2": "137"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822514",
                              "name": "Prawns Biriyani",
                              "category": "Biriyani",
                              "description": "Serves 1",
                              "imageId": "advclisbcydlpxmr8xds",
                              "inStock": 1,
                              "price": 33700,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "68923965",
                                  "groupName": "Egg",
                                  "choices": [
                                    {
                                      "id": "54935061",
                                      "name": "Boiled Egg",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841325",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67891832",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841320",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841316",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841340",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "54156512",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841345",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "60 ratings",
                                  "ratingCountV2": "60"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822519",
                              "name": "Chicken Biriyani",
                              "category": "Biriyani",
                              "description": "Serves 1",
                              "imageId": "wxiqzeafmwowtfuskf1z",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810810",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "LARGE",
                                        "price": 295,
                                        "id": "18813809",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "REGULAR",
                                        "price": 180,
                                        "default": 1,
                                        "id": "18813808",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810810",
                                        "variationId": "18813809"
                                      }
                                    ],
                                    "price": 29500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923396",
                                        "addonId": "54935061"
                                      },
                                      {
                                        "groupId": "67864967",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67864967",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67864967",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67864967",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67864967",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67864967",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67864971",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67864971",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67864971",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67864971",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67864971",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67864971",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67864966",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67864966",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67864966",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67864965",
                                        "addonId": "17505976"
                                      },
                                      {
                                        "groupId": "67864965",
                                        "addonId": "54156510"
                                      },
                                      {
                                        "groupId": "67891740",
                                        "addonId": "54156512"
                                      },
                                      {
                                        "groupId": "67864973",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67864973",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67864973",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67864973",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67864973",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810810",
                                        "variationId": "18813808"
                                      }
                                    ],
                                    "price": 18000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923396",
                                        "addonId": "54935061"
                                      },
                                      {
                                        "groupId": "67864967",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67864967",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67864967",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67864967",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67864967",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67864967",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67864971",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67864971",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67864971",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67864971",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67864971",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67864971",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67864966",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67864966",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67864966",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67864965",
                                        "addonId": "17505976"
                                      },
                                      {
                                        "groupId": "67864965",
                                        "addonId": "54156510"
                                      },
                                      {
                                        "groupId": "67891740",
                                        "addonId": "54156512"
                                      },
                                      {
                                        "groupId": "67864973",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67864973",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67864973",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67864973",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67864973",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923396",
                                  "groupName": "Egg",
                                  "choices": [
                                    {
                                      "id": "54935061",
                                      "name": "Boiled Egg",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67864967",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67864971",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67864966",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67864965",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67891740",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "54156512",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67864973",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 18000,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1443 ratings",
                                  "ratingCountV2": "1443"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822520",
                              "name": "Veg Biriyani",
                              "category": "Biriyani",
                              "description": "Serves 1",
                              "imageId": "kklrjlpk5igqswxwfrga",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21400,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67841197",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841228",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841173",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841165",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841251",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "54156512",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841256",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "84 ratings",
                                  "ratingCountV2": "84"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822576",
                              "name": "Biriyani Rice (non Veg)",
                              "category": "Biriyani",
                              "description": "Serves 1",
                              "imageId": "yaou4iakzffgz8zl8rhj",
                              "inStock": 1,
                              "price": 13000,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "68924001",
                                  "groupName": "Egg",
                                  "choices": [
                                    {
                                      "id": "54935061",
                                      "name": "Boiled Egg",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842001",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842039",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841997",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841992",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842072",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "54156512",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842075",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "458 ratings",
                                  "ratingCountV2": "458"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Empire Special Combo Meals",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "54867885",
                              "name": "Ghee Rice With Dal Fry",
                              "category": "Empire Special Combo Meals",
                              "description": "Serves 1 | Ghee Rice, Dal Fry.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67843725",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843732",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843778",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843709",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843800",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "329 ratings",
                                  "ratingCountV2": "329"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85624514",
                              "name": "Ghee Rice with Paneer Butter Masala & Gobi Manchurian",
                              "category": "Empire Special Combo Meals",
                              "description": "Serves 1 | Ghee Rice, Paneer Butter Masala (5 pcs), Gobi Manchurian",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67891925",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67891926",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67891927",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67891924",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67891928",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "346 ratings",
                                  "ratingCountV2": "346"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85624515",
                              "name": "Veg Fried Rice & Gobi Manchurian",
                              "category": "Empire Special Combo Meals",
                              "description": "Serves 1 | Veg Fried Rice, Gobi Manchurian.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67843844",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843851",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843869",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843841",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843922",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "58 ratings",
                                  "ratingCountV2": "58"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85624505",
                              "name": "2 Naan, Paneer Butter Masala, Gobi Manchurian",
                              "category": "Empire Special Combo Meals",
                              "description": "Serves 1 | 2Naan,Paneer Butter Masala (5 pcs),Gobi Manchurian",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67843065",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843070",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843093",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843063",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843115",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "156 ratings",
                                  "ratingCountV2": "156"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85624502",
                              "name": "3 Coin Parotta, Hyderabadi Boneless Chicken Gravy & Popcorn Kebab",
                              "category": "Empire Special Combo Meals",
                              "description": "Serves 1 | Coin Parotta (2 Nos), Hyderabadi Chicken Boneless (5 Pcs), Popcorn Kebab (5 Pcs)",
                              "inStock": 1,
                              "price": 20900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67842919",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842930",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842970",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842917",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843025",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "127 ratings",
                                  "ratingCountV2": "127"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85624506",
                              "name": "Biriyani Rice, Raitha & Pepper Chicken Boneless",
                              "category": "Empire Special Combo Meals",
                              "description": "Serves 1 | Biriyani Rice, Raitha, Pepper Chicken Bonless (5 Pcs)",
                              "inStock": 1,
                              "price": 16900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "68924069",
                                  "groupName": "Egg",
                                  "choices": [
                                    {
                                      "id": "54935061",
                                      "name": "Boiled Egg",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843182",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843204",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843233",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843187",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843167",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843253",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "214 ratings",
                                  "ratingCountV2": "214"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85624507",
                              "name": "Chicken Biriyani (Regular), Raitha &Popcorn Kebab",
                              "category": "Empire Special Combo Meals",
                              "description": "Serves 1 | Chicken Biriyani (Regular), Raitha, Popcorn Kebab (5 Pcs)",
                              "inStock": 1,
                              "price": 20900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "68924078",
                                  "groupName": "Egg",
                                  "choices": [
                                    {
                                      "id": "54935061",
                                      "name": "Boiled Egg",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843313",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843333",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843354",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843325",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843309",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843383",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "222 ratings",
                                  "ratingCountV2": "222"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85624508",
                              "name": "Ghee Rice Butter Chicken Combo",
                              "category": "Empire Special Combo Meals",
                              "description": "Serves 1 | Ghee Rice, Butter Chicken Boneless (5 Pcs).",
                              "inStock": 1,
                              "price": 14900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67843426",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843450",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843491",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843423",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843520",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "339 ratings",
                                  "ratingCountV2": "339"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85624509",
                              "name": "Ghee Rice, Butter Chicken Combo & Chicken Manchurian Dry",
                              "category": "Empire Special Combo Meals",
                              "description": "Serves 1 | Ghee Rice, Butter Chicken Boneless (5 Pcs), Manchurian Dry (5 Pcs)",
                              "inStock": 1,
                              "price": 18900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67843583",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843595",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843631",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843557",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67843649",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "509 ratings",
                                  "ratingCountV2": "509"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Empire Special Biryani",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215160",
                              "name": "Grilled Chicken Biryani",
                              "category": "Empire Special Biryani",
                              "description": "Serves 1",
                              "imageId": "zmz8cvbu6lstifyvdftl",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "12307838",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 698,
                                        "id": "40195395",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 372,
                                        "default": 1,
                                        "id": "40195396",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "12307838",
                                        "variationId": "40195395"
                                      }
                                    ],
                                    "price": 69800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923415",
                                        "addonId": "54935061"
                                      },
                                      {
                                        "groupId": "67835796",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67835796",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67835796",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67835816",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67835816",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67835816",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67835816",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67835816",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67835816",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67835809",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835809",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835809",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835824",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835824",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835824",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835824",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835824",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835824",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835802",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835802",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835802",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835792",
                                        "addonId": "17505976"
                                      },
                                      {
                                        "groupId": "67835792",
                                        "addonId": "54156510"
                                      },
                                      {
                                        "groupId": "67835828",
                                        "addonId": "54156512"
                                      },
                                      {
                                        "groupId": "67835830",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835830",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835830",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835830",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835830",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "12307838",
                                        "variationId": "40195396"
                                      }
                                    ],
                                    "price": 37200,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923415",
                                        "addonId": "54935061"
                                      },
                                      {
                                        "groupId": "67835796",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67835796",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67835796",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67835816",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67835816",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67835816",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67835816",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67835816",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67835816",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67835809",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835809",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835809",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835824",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835824",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835824",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835824",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835824",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835824",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835802",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835802",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835802",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835792",
                                        "addonId": "17505976"
                                      },
                                      {
                                        "groupId": "67835792",
                                        "addonId": "54156510"
                                      },
                                      {
                                        "groupId": "67835828",
                                        "addonId": "54156512"
                                      },
                                      {
                                        "groupId": "67835830",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835830",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835830",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835830",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835830",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923415",
                                  "groupName": "Egg",
                                  "choices": [
                                    {
                                      "id": "54935061",
                                      "name": "Boiled Egg",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835796",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835816",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835809",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835824",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835802",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835792",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835828",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "54156512",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835830",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 37200,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "379 ratings",
                                  "ratingCountV2": "379"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Bucket Biriyani",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65669680",
                              "name": "Bucket Chicken Biriyani",
                              "category": "Bucket Biriyani",
                              "description": "Serves 7",
                              "imageId": "o3md7bihfchbxxrcfbgu",
                              "inStock": 1,
                              "price": 126000,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "68924013",
                                  "groupName": "Egg",
                                  "choices": [
                                    {
                                      "id": "54935061",
                                      "name": "Boiled Egg",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842130",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842149",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842126",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842122",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842154",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "54156512",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842158",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 7"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "49 ratings",
                                  "ratingCountV2": "49"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65669682",
                              "name": "Bucket Biriyani With Grilled Chicken",
                              "category": "Bucket Biriyani",
                              "description": "Serves 7",
                              "inStock": 1,
                              "price": 161700,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "68924023",
                                  "groupName": "Egg",
                                  "choices": [
                                    {
                                      "id": "54935061",
                                      "name": "Boiled Egg",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842237",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842257",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842229",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842216",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842187",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842299",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "54156512",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842302",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67891844",
                                  "groupName": "Bread",
                                  "choices": [
                                    {
                                      "id": "54168863",
                                      "name": "Kuboos",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 7"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65669684",
                              "name": "Bucket Biriyani With Chicken Kabab",
                              "category": "Bucket Biriyani",
                              "description": "Serves 7",
                              "imageId": "ivjkz6qcirckeynmccj1",
                              "inStock": 1,
                              "price": 157500,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "68924037",
                                  "groupName": "Egg",
                                  "choices": [
                                    {
                                      "id": "54935061",
                                      "name": "Boiled Egg",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842345",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842369",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842342",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842338",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842390",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "54156512",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842393",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 7"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65669685",
                              "name": "Bucket Biriyani With Fiery Wings",
                              "category": "Bucket Biriyani",
                              "description": "Serves 7",
                              "imageId": "qvnrbktvk7whi0qzcoau",
                              "inStock": 1,
                              "price": 163100,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "68924045",
                                  "groupName": "Egg",
                                  "choices": [
                                    {
                                      "id": "54935061",
                                      "name": "Boiled Egg",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842447",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842459",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842443",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842440",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842472",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "54156512",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842475",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 7"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65669686",
                              "name": "Bucket Biriyani With Kalmi Kabab",
                              "category": "Bucket Biriyani",
                              "description": "Serves 7",
                              "imageId": "kmz6vppi99urueddhba4",
                              "inStock": 1,
                              "price": 167000,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "68924051",
                                  "groupName": "Egg",
                                  "choices": [
                                    {
                                      "id": "54935061",
                                      "name": "Boiled Egg",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842505",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842545",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842499",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842495",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842562",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "54156512",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842565",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 7"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Empire Special Chicken (Dry)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822614",
                              "name": "Pepper Chicken Dry Boneless",
                              "category": "Empire Special Chicken (Dry)",
                              "description": "Serves 1",
                              "imageId": "jzjh2o2tntz1kpp8bxug",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810885",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 480,
                                        "id": "18814020",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 252,
                                        "id": "18814019",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 143,
                                        "default": 1,
                                        "id": "18814018",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810885",
                                        "variationId": "18814020"
                                      }
                                    ],
                                    "price": 48000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838284",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67838284",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67838284",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67838289",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67838289",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67838289",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67838289",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67838289",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67838289",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67838281",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67838281",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67838281",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67838304",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838304",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838304",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838304",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838304",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810885",
                                        "variationId": "18814019"
                                      }
                                    ],
                                    "price": 25200,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838284",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67838284",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67838284",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67838289",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67838289",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67838289",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67838289",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67838289",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67838289",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67838281",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67838281",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67838281",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67838304",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838304",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838304",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838304",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838304",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810885",
                                        "variationId": "18814018"
                                      }
                                    ],
                                    "price": 14300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838284",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67838284",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67838284",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67838289",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67838289",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67838289",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67838289",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67838289",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67838289",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67838281",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67838281",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67838281",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67838304",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838304",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838304",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838304",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838304",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67838284",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838289",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838281",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838304",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 14300,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "560 ratings",
                                  "ratingCountV2": "560"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822532",
                              "name": "Empire Special Chilly Kebab",
                              "category": "Empire Special Chicken (Dry)",
                              "description": "Serves 1",
                              "imageId": "mwjxnsys86a5apetncxm",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810824",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 420,
                                        "id": "18813851",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 215,
                                        "id": "18813850",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 125,
                                        "default": 1,
                                        "id": "18813849",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810824",
                                        "variationId": "18813851"
                                      }
                                    ],
                                    "price": 42000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835949",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835949",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835949",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835944",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835944",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835944",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810824",
                                        "variationId": "18813850"
                                      }
                                    ],
                                    "price": 21500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835949",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835949",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835949",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835944",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835944",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835944",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810824",
                                        "variationId": "18813849"
                                      }
                                    ],
                                    "price": 12500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835949",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835949",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835949",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835953",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835944",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835944",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835944",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835960",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67835949",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835953",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835944",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835960",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 12500,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "405 ratings",
                                  "ratingCountV2": "405"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215032",
                              "name": "Pepper Chicken Dry",
                              "category": "Empire Special Chicken (Dry)",
                              "description": "Serves 1",
                              "imageId": "nrx3bnvkrvjblpwnejze",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810789",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 449,
                                        "id": "18813752",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 235,
                                        "id": "18813751",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 133,
                                        "default": 1,
                                        "id": "18813750",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810789",
                                        "variationId": "18813752"
                                      }
                                    ],
                                    "price": 44900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835314",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835314",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835314",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835323",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835323",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835323",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835323",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835323",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835323",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835302",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835302",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835302",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835327",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835327",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835327",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835327",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835327",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810789",
                                        "variationId": "18813751"
                                      }
                                    ],
                                    "price": 23500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835314",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835314",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835314",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835323",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835323",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835323",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835323",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835323",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835323",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835302",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835302",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835302",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835327",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835327",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835327",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835327",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835327",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810789",
                                        "variationId": "18813750"
                                      }
                                    ],
                                    "price": 13300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835314",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835314",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835314",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835323",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835323",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835323",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835323",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835323",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835323",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835302",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835302",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835302",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835327",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835327",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835327",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835327",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835327",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67835314",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835323",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835302",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835327",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 13300,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "454 ratings",
                                  "ratingCountV2": "454"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822578",
                              "name": "Chilly Chicken Dry",
                              "category": "Empire Special Chicken (Dry)",
                              "description": "Serves 1",
                              "imageId": "yhq0iyriltkxoyh0yqyl",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810860",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 449,
                                        "id": "18813951",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 235,
                                        "id": "18813950",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 133,
                                        "default": 1,
                                        "id": "18813949",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810860",
                                        "variationId": "18813951"
                                      }
                                    ],
                                    "price": 44900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810860",
                                        "variationId": "18813950"
                                      }
                                    ],
                                    "price": 23500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810860",
                                        "variationId": "18813949"
                                      }
                                    ],
                                    "price": 13300
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 13300,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "151 ratings",
                                  "ratingCountV2": "151"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "4300494",
                              "name": "Popcorn Chicken Kebab",
                              "category": "Empire Special Chicken (Dry)",
                              "description": "Serves 1",
                              "imageId": "irvoj3hrrcsu5t5n3wx8",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810784",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 490,
                                        "id": "18813738",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 255,
                                        "id": "18813737",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 137,
                                        "default": 1,
                                        "id": "18813736",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810784",
                                        "variationId": "18813738"
                                      }
                                    ],
                                    "price": 49000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835113",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835113",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835113",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835111",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835111",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835111",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810784",
                                        "variationId": "18813737"
                                      }
                                    ],
                                    "price": 25500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835113",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835113",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835113",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835111",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835111",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835111",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810784",
                                        "variationId": "18813736"
                                      }
                                    ],
                                    "price": 13700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835113",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835113",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835113",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835120",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835111",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835111",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835111",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835125",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67835113",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835120",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835111",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835125",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 13700,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "859 ratings",
                                  "ratingCountV2": "859"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215037",
                              "name": "Grilled Chicken",
                              "category": "Empire Special Chicken (Dry)",
                              "description": "Serves 1",
                              "imageId": "wyxryeipwcmz4q6hen2h",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810794",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 420,
                                        "id": "18813765",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 214,
                                        "default": 1,
                                        "id": "18813764",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810794",
                                        "variationId": "18813765"
                                      }
                                    ],
                                    "price": 42000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835557",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835557",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835557",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835542",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835542",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835542",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835580",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835580",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835580",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835580",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835580",
                                        "addonId": "54156429"
                                      },
                                      {
                                        "groupId": "67866479",
                                        "addonId": "54168863"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810794",
                                        "variationId": "18813764"
                                      }
                                    ],
                                    "price": 21400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835557",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835557",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835557",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835568",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835542",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835542",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835542",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835580",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835580",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835580",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835580",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835580",
                                        "addonId": "54156429"
                                      },
                                      {
                                        "groupId": "67866479",
                                        "addonId": "54168863"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67835557",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835568",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835542",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835580",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67866479",
                                  "groupName": "Bread",
                                  "choices": [
                                    {
                                      "id": "54168863",
                                      "name": "Kuboos",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 21400,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "9402 ratings",
                                  "ratingCountV2": "9402"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822492",
                              "name": "Chicken Kebab Boneless",
                              "category": "Empire Special Chicken (Dry)",
                              "description": "Serves 1",
                              "imageId": "sexytz31r1pqfx5xomd5",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810786",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 490,
                                        "id": "18813744",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 255,
                                        "id": "18813743",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 132,
                                        "default": 1,
                                        "id": "18813742",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810786",
                                        "variationId": "18813744"
                                      }
                                    ],
                                    "price": 49000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835237",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835237",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835237",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835242",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835242",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835242",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835242",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835242",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835242",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835230",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835230",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835230",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835275",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835275",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835275",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835275",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835275",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810786",
                                        "variationId": "18813743"
                                      }
                                    ],
                                    "price": 25500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835237",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835237",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835237",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835242",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835242",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835242",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835242",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835242",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835242",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835230",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835230",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835230",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835275",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835275",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835275",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835275",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835275",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810786",
                                        "variationId": "18813742"
                                      }
                                    ],
                                    "price": 13200,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835237",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835237",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835237",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835242",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835242",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835242",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835242",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835242",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835242",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835230",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835230",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835230",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835275",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835275",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835275",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835275",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835275",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67835237",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835242",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835230",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835275",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 13200,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "388 ratings",
                                  "ratingCountV2": "388"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822505",
                              "name": "Empire Special Chicken Kebab",
                              "category": "Empire Special Chicken (Dry)",
                              "description": "Serves 1",
                              "imageId": "obqi7kmdulkmoyrbbx1g",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810800",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 377,
                                        "id": "18813783",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 194,
                                        "id": "18813782",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 107,
                                        "default": 1,
                                        "id": "18813781",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810800",
                                        "variationId": "18813783"
                                      }
                                    ],
                                    "price": 37700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835673",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835673",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835673",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835670",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835670",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835670",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810800",
                                        "variationId": "18813782"
                                      }
                                    ],
                                    "price": 19400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835673",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835673",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835673",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835670",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835670",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835670",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810800",
                                        "variationId": "18813781"
                                      }
                                    ],
                                    "price": 10700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835673",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835673",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835673",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835677",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835670",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835670",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835670",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835696",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67835673",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835677",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835670",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835696",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 10700,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "5116 ratings",
                                  "ratingCountV2": "5116"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822547",
                              "name": "Alfaham Chicken",
                              "category": "Empire Special Chicken (Dry)",
                              "description": "Serves 1",
                              "imageId": "2e675d94449140ec4a4954c992533725",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810833",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 462,
                                        "id": "18813875",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 245,
                                        "id": "18813874",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 138,
                                        "default": 1,
                                        "id": "18813873",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810833",
                                        "variationId": "18813875"
                                      }
                                    ],
                                    "price": 46200,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67836197",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67836197",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67836197",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67836203",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67836203",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67836203",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67836203",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67836203",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67836203",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67836191",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67836191",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67836191",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67836215",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836215",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836215",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836215",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836215",
                                        "addonId": "54156429"
                                      },
                                      {
                                        "groupId": "67866511",
                                        "addonId": "54168863"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810833",
                                        "variationId": "18813874"
                                      }
                                    ],
                                    "price": 24500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67836197",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67836197",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67836197",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67836203",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67836203",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67836203",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67836203",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67836203",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67836203",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67836191",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67836191",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67836191",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67836215",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836215",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836215",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836215",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836215",
                                        "addonId": "54156429"
                                      },
                                      {
                                        "groupId": "67866511",
                                        "addonId": "54168863"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810833",
                                        "variationId": "18813873"
                                      }
                                    ],
                                    "price": 13800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67836197",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67836197",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67836197",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67836203",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67836203",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67836203",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67836203",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67836203",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67836203",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67836191",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67836191",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67836191",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67836215",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836215",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836215",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836215",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836215",
                                        "addonId": "54156429"
                                      },
                                      {
                                        "groupId": "67866511",
                                        "addonId": "54168863"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67836197",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836203",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836191",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836215",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67866511",
                                  "groupName": "Bread",
                                  "choices": [
                                    {
                                      "id": "54168863",
                                      "name": "Kuboos",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 13800,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "910 ratings",
                                  "ratingCountV2": "910"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822573",
                              "name": "Chicken Manchurian Boneless",
                              "category": "Empire Special Chicken (Dry)",
                              "description": "Serves 1",
                              "imageId": "gloajcuovqkezogtpfud",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "8244229",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 484,
                                        "id": "27551810",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 252,
                                        "id": "27551809",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 137,
                                        "default": 1,
                                        "id": "27551808",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "8244229",
                                        "variationId": "27551810"
                                      }
                                    ],
                                    "price": 48400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67836982",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67836982",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67836982",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67836987",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67836987",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67836987",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67836987",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67836987",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67836987",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67836975",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67836975",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67836975",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67836998",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836998",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836998",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836998",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836998",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "8244229",
                                        "variationId": "27551809"
                                      }
                                    ],
                                    "price": 25200,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67836982",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67836982",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67836982",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67836987",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67836987",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67836987",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67836987",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67836987",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67836987",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67836975",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67836975",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67836975",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67836998",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836998",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836998",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836998",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836998",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "8244229",
                                        "variationId": "27551808"
                                      }
                                    ],
                                    "price": 13700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67836982",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67836982",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67836982",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67836987",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67836987",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67836987",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67836987",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67836987",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67836987",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67836975",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67836975",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67836975",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67836998",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836998",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836998",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836998",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836998",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67836982",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836987",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836975",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836998",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 13700,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "182 ratings",
                                  "ratingCountV2": "182"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822609",
                              "name": "Chilly Chicken Boneless",
                              "category": "Empire Special Chicken (Dry)",
                              "description": "Serves 1",
                              "imageId": "jkyfek2e4uuwxduqec89",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810879",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 470,
                                        "id": "18814002",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 247,
                                        "id": "18814001",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 140,
                                        "default": 1,
                                        "id": "18814000",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810879",
                                        "variationId": "18814002"
                                      }
                                    ],
                                    "price": 47000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838071",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67838071",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67838071",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67838079",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67838079",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67838079",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67838079",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67838079",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67838079",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67838067",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67838067",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67838067",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67838091",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838091",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838091",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838091",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838091",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810879",
                                        "variationId": "18814001"
                                      }
                                    ],
                                    "price": 24700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838071",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67838071",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67838071",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67838079",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67838079",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67838079",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67838079",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67838079",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67838079",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67838067",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67838067",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67838067",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67838091",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838091",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838091",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838091",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838091",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810879",
                                        "variationId": "18814000"
                                      }
                                    ],
                                    "price": 14000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838071",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67838071",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67838071",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67838079",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67838079",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67838079",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67838079",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67838079",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67838079",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67838067",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67838067",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67838067",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67838091",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838091",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838091",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838091",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838091",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67838071",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838079",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838067",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838091",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 14000,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "303 ratings",
                                  "ratingCountV2": "303"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Tandoori(dry)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822501",
                              "name": "Kalmi Kabab",
                              "category": "Tandoori(dry)",
                              "description": "Serves 1",
                              "imageId": "ymipyekw4xeq0mkufsl8",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810797",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 500,
                                        "id": "18813774",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 275,
                                        "id": "18813773",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 150,
                                        "default": 1,
                                        "id": "18813772",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810797",
                                        "variationId": "18813774"
                                      }
                                    ],
                                    "price": 50000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835637",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835637",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835637",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835627",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835627",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835627",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835642",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835642",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835642",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835642",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835642",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810797",
                                        "variationId": "18813773"
                                      }
                                    ],
                                    "price": 27500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835637",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835637",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835637",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835627",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835627",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835627",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835642",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835642",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835642",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835642",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835642",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810797",
                                        "variationId": "18813772"
                                      }
                                    ],
                                    "price": 15000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835637",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67835637",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67835637",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67835627",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67835627",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67835627",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67835642",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835642",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835642",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835642",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835642",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67835637",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835627",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835642",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 15000,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "73 ratings",
                                  "ratingCountV2": "73"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822570",
                              "name": "Murg Tikka",
                              "category": "Tandoori(dry)",
                              "description": "Serves 1",
                              "imageId": "nncv1qc5djsgljrs2eoz",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810850",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 500,
                                        "id": "18813923",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 255,
                                        "id": "18813922",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 150,
                                        "default": 1,
                                        "id": "18813921",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810850",
                                        "variationId": "18813923"
                                      }
                                    ],
                                    "price": 50000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67836747",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67836747",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67836747",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67836743",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67836743",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67836743",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67836756",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836756",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836756",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836756",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836756",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810850",
                                        "variationId": "18813922"
                                      }
                                    ],
                                    "price": 25500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67836747",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67836747",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67836747",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67836743",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67836743",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67836743",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67836756",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836756",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836756",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836756",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836756",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810850",
                                        "variationId": "18813921"
                                      }
                                    ],
                                    "price": 15000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67836747",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67836747",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67836747",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67836743",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67836743",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67836743",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67836756",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836756",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836756",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836756",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836756",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67836747",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836743",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836756",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 15000,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "41 ratings",
                                  "ratingCountV2": "41"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822628",
                              "name": "Murg Hariyali Tikka",
                              "category": "Tandoori(dry)",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810898",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 500,
                                        "id": "18814056",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 255,
                                        "id": "18814055",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 150,
                                        "default": 1,
                                        "id": "18814054",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810898",
                                        "variationId": "18814056"
                                      }
                                    ],
                                    "price": 50000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67839024",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67839024",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67839024",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67839017",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67839017",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67839017",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67839035",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839035",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839035",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839035",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839035",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810898",
                                        "variationId": "18814055"
                                      }
                                    ],
                                    "price": 25500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67839024",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67839024",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67839024",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67839017",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67839017",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67839017",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67839035",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839035",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839035",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839035",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839035",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810898",
                                        "variationId": "18814054"
                                      }
                                    ],
                                    "price": 15000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67839024",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67839024",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67839024",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67839017",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67839017",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67839017",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67839035",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839035",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839035",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839035",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839035",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67839024",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839017",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839035",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 15000,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "362 ratings",
                                  "ratingCountV2": "362"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822660",
                              "name": "Tandoori Chicken",
                              "category": "Tandoori(dry)",
                              "description": "Serves 1",
                              "imageId": "gb5pcoodwyyssr9fjgjl",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810925",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 460,
                                        "id": "18814130",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 245,
                                        "id": "18814129",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 140,
                                        "default": 1,
                                        "id": "18814128",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810925",
                                        "variationId": "18814130"
                                      }
                                    ],
                                    "price": 46000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67840877",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67840877",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67840877",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67840857",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67840857",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67840857",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67840890",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67840890",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67840890",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67840890",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67840890",
                                        "addonId": "54156429"
                                      },
                                      {
                                        "groupId": "67866563",
                                        "addonId": "54168863"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810925",
                                        "variationId": "18814129"
                                      }
                                    ],
                                    "price": 24500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67840877",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67840877",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67840877",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67840857",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67840857",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67840857",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67840890",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67840890",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67840890",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67840890",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67840890",
                                        "addonId": "54156429"
                                      },
                                      {
                                        "groupId": "67866563",
                                        "addonId": "54168863"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810925",
                                        "variationId": "18814128"
                                      }
                                    ],
                                    "price": 14000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67840877",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67840877",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67840877",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67840857",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67840857",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67840857",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67840890",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67840890",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67840890",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67840890",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67840890",
                                        "addonId": "54156429"
                                      },
                                      {
                                        "groupId": "67866563",
                                        "addonId": "54168863"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67840877",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67840857",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67840890",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67866563",
                                  "groupName": "Bread",
                                  "choices": [
                                    {
                                      "id": "54168863",
                                      "name": "Kuboos",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 14000,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "393 ratings",
                                  "ratingCountV2": "393"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Empire Special Mutton (Dry)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822574",
                              "name": "Mutton Pepper Dry",
                              "category": "Empire Special Mutton (Dry)",
                              "description": "Serves 1",
                              "imageId": "tbbdp3koyjvnutggkual",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810856",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 630,
                                        "id": "18813940",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 330,
                                        "id": "18813939",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 185,
                                        "default": 1,
                                        "id": "18813938",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810856",
                                        "variationId": "18813940"
                                      }
                                    ],
                                    "price": 63000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67837014",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67837014",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67837014",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67837014",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67837014",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810856",
                                        "variationId": "18813939"
                                      }
                                    ],
                                    "price": 33000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67837014",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67837014",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67837014",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67837014",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67837014",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810856",
                                        "variationId": "18813938"
                                      }
                                    ],
                                    "price": 18500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67837014",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67837014",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67837014",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67837014",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67837014",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67837014",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 18500,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "78 ratings",
                                  "ratingCountV2": "78"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822610",
                              "name": "Mutton Pepper Dry Boneless",
                              "category": "Empire Special Mutton (Dry)",
                              "description": "Serves 1",
                              "imageId": "r31xfm9x08iok9q0d5qo",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810880",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 645,
                                        "id": "18814005",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 340,
                                        "id": "18814004",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 189,
                                        "default": 1,
                                        "id": "18814003",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810880",
                                        "variationId": "18814005"
                                      }
                                    ],
                                    "price": 64500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838112",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838112",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838112",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838112",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838112",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810880",
                                        "variationId": "18814004"
                                      }
                                    ],
                                    "price": 34000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838112",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838112",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838112",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838112",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838112",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810880",
                                        "variationId": "18814003"
                                      }
                                    ],
                                    "price": 18900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838112",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838112",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838112",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838112",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838112",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67838112",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 18900,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "58 ratings",
                                  "ratingCountV2": "58"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822642",
                              "name": "Mutton Brain Dry Fry",
                              "category": "Empire Special Mutton (Dry)",
                              "description": "Serves 1",
                              "imageId": "yjktl5fctf4g4solnqcy",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810908",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 680,
                                        "id": "18814085",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 340,
                                        "id": "18814084",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 170,
                                        "default": 1,
                                        "id": "18814083",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810908",
                                        "variationId": "18814085"
                                      }
                                    ],
                                    "price": 68000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67839876",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839876",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839876",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839876",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839876",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810908",
                                        "variationId": "18814084"
                                      }
                                    ],
                                    "price": 34000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67839876",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839876",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839876",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839876",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839876",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810908",
                                        "variationId": "18814083"
                                      }
                                    ],
                                    "price": 17000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67839876",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839876",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839876",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839876",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839876",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67839876",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 17000,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "273 ratings",
                                  "ratingCountV2": "273"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Rice",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215169",
                              "name": "Curd Rice",
                              "category": "Rice",
                              "description": "Serves 1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67844116",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67844149",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67844104",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67844096",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67844177",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "398 ratings",
                                  "ratingCountV2": "398"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215170",
                              "name": "Plain Rice",
                              "category": "Rice",
                              "description": "Serves 1",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28683763",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 70,
                                        "default": 1,
                                        "id": "90335373",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 70,
                                        "id": "90335374",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28683763",
                                        "variationId": "90335373"
                                      }
                                    ],
                                    "price": 7000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "94507504",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "94507504",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "94507504",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "94507504",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "94507504",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "94507504",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "94507511",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "94507511",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "94507511",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "94507511",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "94507511",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "94507511",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "94507515",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "94507515",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "94507515",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "94507526",
                                        "addonId": "17505976"
                                      },
                                      {
                                        "groupId": "94507526",
                                        "addonId": "54156510"
                                      },
                                      {
                                        "groupId": "94507533",
                                        "addonId": "54156512"
                                      },
                                      {
                                        "groupId": "94507542",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "94507542",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "94507542",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "94507542",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "94507542",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28683763",
                                        "variationId": "90335374"
                                      }
                                    ],
                                    "price": 7000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "94507504",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "94507504",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "94507504",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "94507504",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "94507504",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "94507504",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "94507511",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "94507511",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "94507511",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "94507511",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "94507511",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "94507511",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "94507515",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "94507515",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "94507515",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "94507526",
                                        "addonId": "17505976"
                                      },
                                      {
                                        "groupId": "94507526",
                                        "addonId": "54156510"
                                      },
                                      {
                                        "groupId": "94507533",
                                        "addonId": "54156512"
                                      },
                                      {
                                        "groupId": "94507542",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "94507542",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "94507542",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "94507542",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "94507542",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "94507504",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "94507511",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "94507515",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "94507526",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "94507533",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "54156512",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "94507542",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 7000,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "343 ratings",
                                  "ratingCountV2": "343"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215166",
                              "name": "Ghee Rice",
                              "category": "Rice",
                              "description": "Serves 1",
                              "imageId": "troivpi2v0ybmdzwwz7l",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "23808629",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 101,
                                        "default": 1,
                                        "id": "77096199",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 101,
                                        "id": "77096200",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808629",
                                        "variationId": "77096199"
                                      }
                                    ],
                                    "price": 10100,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67841722",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67841722",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67841722",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67841722",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67841722",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67841722",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67841735",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67841735",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67841735",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67841735",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67841735",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67841735",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67841713",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67841713",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67841713",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67841710",
                                        "addonId": "17505976"
                                      },
                                      {
                                        "groupId": "67841710",
                                        "addonId": "54156510"
                                      },
                                      {
                                        "groupId": "67841749",
                                        "addonId": "54156512"
                                      },
                                      {
                                        "groupId": "67841754",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67841754",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67841754",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67841754",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67841754",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808629",
                                        "variationId": "77096200"
                                      }
                                    ],
                                    "price": 10100,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67841722",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67841722",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67841722",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67841722",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67841722",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67841722",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67841735",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67841735",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67841735",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67841735",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67841735",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67841735",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67841713",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67841713",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67841713",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67841710",
                                        "addonId": "17505976"
                                      },
                                      {
                                        "groupId": "67841710",
                                        "addonId": "54156510"
                                      },
                                      {
                                        "groupId": "67841749",
                                        "addonId": "54156512"
                                      },
                                      {
                                        "groupId": "67841754",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67841754",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67841754",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67841754",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67841754",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67841722",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841735",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841713",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841710",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841749",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "54156512",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841754",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 10100,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "9131 ratings",
                                  "ratingCountV2": "9131"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215167",
                              "name": "Lemon Rice",
                              "category": "Rice",
                              "description": "Serves 1",
                              "imageId": "vgmmxxdnxv06pjgf3ksw",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "23808621",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 139,
                                        "default": 1,
                                        "id": "77096183",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 139,
                                        "id": "77096184",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808621",
                                        "variationId": "77096183"
                                      }
                                    ],
                                    "price": 13900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67841555",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67841555",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67841555",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67841551",
                                        "addonId": "17505976"
                                      },
                                      {
                                        "groupId": "67841551",
                                        "addonId": "54156510"
                                      },
                                      {
                                        "groupId": "67841593",
                                        "addonId": "54156512"
                                      },
                                      {
                                        "groupId": "67841598",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67841598",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67841598",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67841598",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67841598",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808621",
                                        "variationId": "77096184"
                                      }
                                    ],
                                    "price": 13900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67841561",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67841578",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67841555",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67841555",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67841555",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67841551",
                                        "addonId": "17505976"
                                      },
                                      {
                                        "groupId": "67841551",
                                        "addonId": "54156510"
                                      },
                                      {
                                        "groupId": "67841593",
                                        "addonId": "54156512"
                                      },
                                      {
                                        "groupId": "67841598",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67841598",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67841598",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67841598",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67841598",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67841561",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841578",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841555",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841551",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841593",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "54156512",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841598",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 13900,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "309 ratings",
                                  "ratingCountV2": "309"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215168",
                              "name": "Jeera Rice",
                              "category": "Rice",
                              "description": "Serves 1",
                              "imageId": "vk0r9hgvonmw9zd4ymwp",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "23808622",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 139,
                                        "default": 1,
                                        "id": "77096185",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 139,
                                        "id": "77096186",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808622",
                                        "variationId": "77096185"
                                      }
                                    ],
                                    "price": 13900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67841638",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67841638",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67841638",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67841638",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67841638",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67841638",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67841668",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67841668",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67841668",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67841668",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67841668",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67841668",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67841633",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67841633",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67841633",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67841630",
                                        "addonId": "17505976"
                                      },
                                      {
                                        "groupId": "67841630",
                                        "addonId": "54156510"
                                      },
                                      {
                                        "groupId": "67841685",
                                        "addonId": "54156512"
                                      },
                                      {
                                        "groupId": "67841688",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67841688",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67841688",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67841688",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67841688",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808622",
                                        "variationId": "77096186"
                                      }
                                    ],
                                    "price": 13900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67841638",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67841638",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67841638",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67841638",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67841638",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67841638",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67841668",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67841668",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67841668",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67841668",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67841668",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67841668",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67841633",
                                        "addonId": "54156450"
                                      },
                                      {
                                        "groupId": "67841633",
                                        "addonId": "54156451"
                                      },
                                      {
                                        "groupId": "67841633",
                                        "addonId": "54156452"
                                      },
                                      {
                                        "groupId": "67841630",
                                        "addonId": "17505976"
                                      },
                                      {
                                        "groupId": "67841630",
                                        "addonId": "54156510"
                                      },
                                      {
                                        "groupId": "67841685",
                                        "addonId": "54156512"
                                      },
                                      {
                                        "groupId": "67841688",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67841688",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67841688",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67841688",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67841688",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67841638",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841668",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841633",
                                  "groupName": "Salad",
                                  "choices": [
                                    {
                                      "id": "54156452",
                                      "name": "Green Salad",
                                      "price": 9500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156451",
                                      "name": "Mini Salad",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156450",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841630",
                                  "groupName": "Curd",
                                  "choices": [
                                    {
                                      "id": "17505976",
                                      "name": "Curd",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156510",
                                      "name": "Raitha",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841685",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "54156512",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67841688",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 13900,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "598 ratings",
                                  "ratingCountV2": "598"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Empire Special Mutton (Gravy)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215135",
                              "name": "Pepper Mutton Masala",
                              "category": "Empire Special Mutton (Gravy)",
                              "description": "Serves 1",
                              "imageId": "smhvpyjoep9h1buvkpfl",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810910",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 627,
                                        "id": "18814091",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 322,
                                        "id": "18814090",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 170,
                                        "default": 1,
                                        "id": "18814089",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810910",
                                        "variationId": "18814091"
                                      }
                                    ],
                                    "price": 62700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923867",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67839945",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67839945",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67839945",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67839951",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67839951",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67839951",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67839951",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67839951",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67839951",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67839993",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839993",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839993",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839993",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839993",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810910",
                                        "variationId": "18814090"
                                      }
                                    ],
                                    "price": 32200,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923867",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67839945",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67839945",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67839945",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67839951",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67839951",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67839951",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67839951",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67839951",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67839951",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67839993",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839993",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839993",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839993",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839993",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810910",
                                        "variationId": "18814089"
                                      }
                                    ],
                                    "price": 17000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923867",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67839945",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67839945",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67839945",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67839951",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67839951",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67839951",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67839951",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67839951",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67839951",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67839993",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839993",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839993",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839993",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839993",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923867",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839945",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839951",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839993",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 17000,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "157 ratings",
                                  "ratingCountV2": "157"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215131",
                              "name": "Mutton Brain Masala",
                              "category": "Empire Special Mutton (Gravy)",
                              "description": "Serves 1",
                              "imageId": "adqdbgha4yupdvrd3lmx",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810785",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 693,
                                        "id": "18813741",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 346,
                                        "id": "18813740",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 173,
                                        "default": 1,
                                        "id": "18813739",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810785",
                                        "variationId": "18813741"
                                      }
                                    ],
                                    "price": 69300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923299",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67835203",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67835203",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67835203",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67835208",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67835208",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67835208",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67835208",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67835208",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67835208",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67835217",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835217",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835217",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835217",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835217",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810785",
                                        "variationId": "18813740"
                                      }
                                    ],
                                    "price": 34600,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923299",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67835203",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67835203",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67835203",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67835208",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67835208",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67835208",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67835208",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67835208",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67835208",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67835217",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835217",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835217",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835217",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835217",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810785",
                                        "variationId": "18813739"
                                      }
                                    ],
                                    "price": 17300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923299",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67835203",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67835203",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67835203",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67835208",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67835208",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67835208",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67835208",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67835208",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67835208",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67835217",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835217",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835217",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835217",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835217",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923299",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835203",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835208",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835217",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 17300,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "100 ratings",
                                  "ratingCountV2": "100"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822482",
                              "name": "Mutton Kurma",
                              "category": "Empire Special Mutton (Gravy)",
                              "description": "Serves 1",
                              "imageId": "twjmxjokmjh7g0a7atwf",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810776",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 630,
                                        "id": "18813717",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 325,
                                        "id": "18813716",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 173,
                                        "default": 1,
                                        "id": "18813715",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810776",
                                        "variationId": "18813717"
                                      }
                                    ],
                                    "price": 63000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923273",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67835059",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67835059",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67835059",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67835061",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67835061",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67835061",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67835061",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67835061",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67835061",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67835065",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835065",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835065",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835065",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835065",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810776",
                                        "variationId": "18813716"
                                      }
                                    ],
                                    "price": 32500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923273",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67835059",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67835059",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67835059",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67835061",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67835061",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67835061",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67835061",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67835061",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67835061",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67835065",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835065",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835065",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835065",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835065",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810776",
                                        "variationId": "18813715"
                                      }
                                    ],
                                    "price": 17300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923273",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67835059",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67835059",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67835059",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67835061",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67835061",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67835061",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67835061",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67835061",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67835061",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67835065",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835065",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835065",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835065",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835065",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923273",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835059",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835061",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835065",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 17300,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "47 ratings",
                                  "ratingCountV2": "47"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822549",
                              "name": "Mutton Varuval",
                              "category": "Empire Special Mutton (Gravy)",
                              "description": "Serves 1",
                              "imageId": "bmeksa4b6do9jkpxurz7",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810834",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 630,
                                        "id": "18813878",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 325,
                                        "id": "18813877",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 173,
                                        "default": 1,
                                        "id": "18813876",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810834",
                                        "variationId": "18813878"
                                      }
                                    ],
                                    "price": 63000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923517",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67836280",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67836280",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67836280",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67836282",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67836282",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67836282",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67836282",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67836282",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67836282",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67836302",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836302",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836302",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836302",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836302",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810834",
                                        "variationId": "18813877"
                                      }
                                    ],
                                    "price": 32500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923517",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67836280",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67836280",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67836280",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67836282",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67836282",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67836282",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67836282",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67836282",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67836282",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67836302",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836302",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836302",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836302",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836302",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810834",
                                        "variationId": "18813876"
                                      }
                                    ],
                                    "price": 17300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923517",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67836280",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67836280",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67836280",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67836282",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67836282",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67836282",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67836282",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67836282",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67836282",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67836302",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836302",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836302",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836302",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836302",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923517",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836280",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836282",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836302",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 17300,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "74 ratings",
                                  "ratingCountV2": "74"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Empire Special Chicken (Gravy)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822543",
                              "name": "Pepper Chicken Masala",
                              "category": "Empire Special Chicken (Gravy)",
                              "description": "Serves 1",
                              "imageId": "flq53krkpkjkhod7zrwr",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810830",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 480,
                                        "id": "18813867",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 255,
                                        "id": "18813866",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 143,
                                        "default": 1,
                                        "id": "18813865",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810830",
                                        "variationId": "18813867"
                                      }
                                    ],
                                    "price": 48000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923504",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67836082",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67836082",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67836082",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67836087",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67836087",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67836087",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67836087",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67836087",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67836087",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67836094",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836094",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836094",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836094",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836094",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810830",
                                        "variationId": "18813866"
                                      }
                                    ],
                                    "price": 25500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923504",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67836082",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67836082",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67836082",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67836087",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67836087",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67836087",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67836087",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67836087",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67836087",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67836094",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836094",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836094",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836094",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836094",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810830",
                                        "variationId": "18813865"
                                      }
                                    ],
                                    "price": 14300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923504",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67836082",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67836082",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67836082",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67836087",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67836087",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67836087",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67836087",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67836087",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67836087",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67836094",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836094",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836094",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836094",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836094",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923504",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836082",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836087",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836094",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 14300,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "181 ratings",
                                  "ratingCountV2": "181"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215100",
                              "name": "Chicken Manchurian Masala",
                              "category": "Empire Special Chicken (Gravy)",
                              "description": "Serves 1",
                              "imageId": "ks5nvn1d9ufzq7bxifvu",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810913",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 500,
                                        "id": "18814099",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 265,
                                        "id": "18814098",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 153,
                                        "default": 1,
                                        "id": "18814097",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810913",
                                        "variationId": "18814099"
                                      }
                                    ],
                                    "price": 50000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923885",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67840048",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67840048",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67840048",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67840057",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67840057",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67840057",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67840057",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67840057",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67840057",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67840080",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67840080",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67840080",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67840080",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67840080",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810913",
                                        "variationId": "18814098"
                                      }
                                    ],
                                    "price": 26500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923885",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67840048",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67840048",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67840048",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67840057",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67840057",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67840057",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67840057",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67840057",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67840057",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67840080",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67840080",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67840080",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67840080",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67840080",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810913",
                                        "variationId": "18814097"
                                      }
                                    ],
                                    "price": 15300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923885",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67840048",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67840048",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67840048",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67840057",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67840057",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67840057",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67840057",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67840057",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67840057",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67840080",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67840080",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67840080",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67840080",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67840080",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923885",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67840048",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67840057",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67840080",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 15300,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "100 ratings",
                                  "ratingCountV2": "100"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215108",
                              "name": "Chicken Masala",
                              "category": "Empire Special Chicken (Gravy)",
                              "description": "Serves 1",
                              "imageId": "jnd6i6omxpfa3nosk8zy",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810791",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 484,
                                        "id": "18813757",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 255,
                                        "id": "18813756",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 143,
                                        "default": 1,
                                        "id": "18813755",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810791",
                                        "variationId": "18813757"
                                      }
                                    ],
                                    "price": 48400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923309",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67835406",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67835406",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67835406",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67835411",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67835411",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67835411",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67835411",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67835411",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67835411",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67835429",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835429",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835429",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835429",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835429",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810791",
                                        "variationId": "18813756"
                                      }
                                    ],
                                    "price": 25500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923309",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67835406",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67835406",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67835406",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67835411",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67835411",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67835411",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67835411",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67835411",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67835411",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67835429",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835429",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835429",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835429",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835429",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810791",
                                        "variationId": "18813755"
                                      }
                                    ],
                                    "price": 14300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923309",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67835406",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67835406",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67835406",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67835411",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67835411",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67835411",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67835411",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67835411",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67835411",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67835429",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835429",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835429",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835429",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835429",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923309",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835406",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835411",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835429",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 14300,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "305 ratings",
                                  "ratingCountV2": "305"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215110",
                              "name": "Chicken Tikka Masala",
                              "category": "Empire Special Chicken (Gravy)",
                              "description": "Serves 1",
                              "imageId": "icpycagtwmqflonmjud8",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810906",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 515,
                                        "id": "18814079",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 273,
                                        "id": "18814078",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 153,
                                        "default": 1,
                                        "id": "18814077",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810906",
                                        "variationId": "18814079"
                                      }
                                    ],
                                    "price": 51500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923857",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67839762",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67839762",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67839762",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810906",
                                        "variationId": "18814078"
                                      }
                                    ],
                                    "price": 27300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923857",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67839762",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67839762",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67839762",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810906",
                                        "variationId": "18814077"
                                      }
                                    ],
                                    "price": 15300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923857",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67839762",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67839762",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67839762",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67839769",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839808",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923857",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839762",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839769",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839808",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 15300,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "1070 ratings",
                                  "ratingCountV2": "1070"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215111",
                              "name": "Chicken Tandoori Masala",
                              "category": "Empire Special Chicken (Gravy)",
                              "description": "Serves 1",
                              "imageId": "l9jc37cdfdc0nnpk49ln",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810917",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 510,
                                        "id": "18814109",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 275,
                                        "id": "18814108",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 158,
                                        "default": 1,
                                        "id": "18814107",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810917",
                                        "variationId": "18814109"
                                      }
                                    ],
                                    "price": 51000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923893",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67840315",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67840315",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67840315",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67840319",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67840319",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67840319",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67840319",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67840319",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67840319",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67840339",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67840339",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67840339",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67840339",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67840339",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810917",
                                        "variationId": "18814108"
                                      }
                                    ],
                                    "price": 27500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923893",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67840315",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67840315",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67840315",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67840319",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67840319",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67840319",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67840319",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67840319",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67840319",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67840339",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67840339",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67840339",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67840339",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67840339",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810917",
                                        "variationId": "18814107"
                                      }
                                    ],
                                    "price": 15800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923893",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67840315",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67840315",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67840315",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67840319",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67840319",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67840319",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67840319",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67840319",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67840319",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67840339",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67840339",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67840339",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67840339",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67840339",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923893",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67840315",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67840319",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67840339",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 15800,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "276 ratings",
                                  "ratingCountV2": "276"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822498",
                              "name": "Chicken Kurma",
                              "category": "Empire Special Chicken (Gravy)",
                              "description": "Serves 1",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810793",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 490,
                                        "id": "18813762",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 255,
                                        "id": "18813761",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 143,
                                        "default": 1,
                                        "id": "18813760",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810793",
                                        "variationId": "18813762"
                                      }
                                    ],
                                    "price": 49000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923345",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67835486",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67835486",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67835486",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67835488",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67835488",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67835488",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67835488",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67835488",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67835488",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67835511",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835511",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835511",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835511",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835511",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810793",
                                        "variationId": "18813761"
                                      }
                                    ],
                                    "price": 25500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923345",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67835486",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67835486",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67835486",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67835488",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67835488",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67835488",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67835488",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67835488",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67835488",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67835511",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835511",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835511",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835511",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835511",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810793",
                                        "variationId": "18813760"
                                      }
                                    ],
                                    "price": 14300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923345",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67835486",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67835486",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67835486",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67835488",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67835488",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67835488",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67835488",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67835488",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67835488",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67835511",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835511",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835511",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835511",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835511",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923345",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835486",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835488",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835511",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 14300,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "51 ratings",
                                  "ratingCountV2": "51"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822535",
                              "name": "Butter Chicken",
                              "category": "Empire Special Chicken (Gravy)",
                              "description": "Serves 1",
                              "imageId": "kywkfwwyqscindrzh1fa",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810825",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 484,
                                        "id": "18813854",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 255,
                                        "id": "18813853",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 143,
                                        "default": 1,
                                        "id": "18813852",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810825",
                                        "variationId": "18813854"
                                      }
                                    ],
                                    "price": 48400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923482",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67836035",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67836035",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67836035",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67836041",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67836041",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67836041",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67836041",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67836041",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67836041",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67836052",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836052",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836052",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836052",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836052",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810825",
                                        "variationId": "18813853"
                                      }
                                    ],
                                    "price": 25500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923482",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67836035",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67836035",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67836035",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67836041",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67836041",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67836041",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67836041",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67836041",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67836041",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67836052",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836052",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836052",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836052",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836052",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810825",
                                        "variationId": "18813852"
                                      }
                                    ],
                                    "price": 14300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923482",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67836035",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67836035",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67836035",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67836041",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67836041",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67836041",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67836041",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67836041",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67836041",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67836052",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836052",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836052",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836052",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836052",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923482",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836035",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836041",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836052",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 14300,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "486 ratings",
                                  "ratingCountV2": "486"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822601",
                              "name": "Butter Chicken Boneless",
                              "category": "Empire Special Chicken (Gravy)",
                              "description": "Serves 1",
                              "imageId": "vbtgihmcmseeizl1iuma",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810875",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 500,
                                        "id": "18813991",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 265,
                                        "id": "18813990",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 153,
                                        "default": 1,
                                        "id": "18813989",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810875",
                                        "variationId": "18813991"
                                      }
                                    ],
                                    "price": 50000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923621",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67837898",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67837898",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67837898",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810875",
                                        "variationId": "18813990"
                                      }
                                    ],
                                    "price": 26500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923621",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67837898",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67837898",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67837898",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810875",
                                        "variationId": "18813989"
                                      }
                                    ],
                                    "price": 15300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923621",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67837898",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67837898",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67837898",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67837909",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67837929",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923621",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67837898",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67837909",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67837929",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 15300,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "949 ratings",
                                  "ratingCountV2": "949"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822617",
                              "name": "Chicken Varval",
                              "category": "Empire Special Chicken (Gravy)",
                              "description": "Serves 1",
                              "imageId": "mk3acltmonkzutknsqny",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810887",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 480,
                                        "id": "18814025",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 255,
                                        "id": "18814024",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 143,
                                        "default": 1,
                                        "id": "18814023",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810887",
                                        "variationId": "18814025"
                                      }
                                    ],
                                    "price": 48000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923663",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67838418",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67838418",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67838418",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810887",
                                        "variationId": "18814024"
                                      }
                                    ],
                                    "price": 25500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923663",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67838418",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67838418",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67838418",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810887",
                                        "variationId": "18814023"
                                      }
                                    ],
                                    "price": 14300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923663",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67838418",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67838418",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67838418",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838427",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838446",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923663",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838418",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838427",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838446",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 14300,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "258 ratings",
                                  "ratingCountV2": "258"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Parottas",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215180",
                              "name": "Dry Chapati",
                              "category": "Parottas",
                              "description": "Serves 1",
                              "imageId": "vujildtrdyn6temnxvio",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "23808602",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 30,
                                        "default": 1,
                                        "id": "77096145",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 30,
                                        "id": "77096146",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808602",
                                        "variationId": "77096145"
                                      }
                                    ],
                                    "price": 3000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838969",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838969",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838969",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838969",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838969",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838969",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838986",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67838986",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67838986",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67838986",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67838986",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67838986",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67838998",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838998",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838998",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838998",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838998",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808602",
                                        "variationId": "77096146"
                                      }
                                    ],
                                    "price": 3000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838969",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838969",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838969",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838969",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838969",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838969",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838986",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67838986",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67838986",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67838986",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67838986",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67838986",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67838998",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838998",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838998",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838998",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838998",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67838969",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838986",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838998",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 3000,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "691 ratings",
                                  "ratingCountV2": "691"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822584",
                              "name": "Egg Parotta",
                              "category": "Parottas",
                              "description": "Serves 1",
                              "imageId": "fdreyhmkuy5uqcsp4yj4",
                              "inStock": 1,
                              "price": 9100,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67837329",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67837341",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67837355",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "75 ratings",
                                  "ratingCountV2": "75"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215184",
                              "name": "Kerala Parotta",
                              "category": "Parottas",
                              "description": "Serves 1",
                              "imageId": "pwgx9hyprqwfn7nzbxew",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "23808588",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 37,
                                        "default": 1,
                                        "id": "77096117",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 37,
                                        "id": "77096118",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808588",
                                        "variationId": "77096117"
                                      }
                                    ],
                                    "price": 3700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67837727",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67837727",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67837727",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67837727",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67837727",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67837727",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67837773",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67837773",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67837773",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67837773",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67837773",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67837773",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67837789",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67837789",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67837789",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67837789",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67837789",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808588",
                                        "variationId": "77096118"
                                      }
                                    ],
                                    "price": 3700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67837727",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67837727",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67837727",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67837727",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67837727",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67837727",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67837773",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67837773",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67837773",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67837773",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67837773",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67837773",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67837789",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67837789",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67837789",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67837789",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67837789",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67837727",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67837773",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67837789",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 3700,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "1985 ratings",
                                  "ratingCountV2": "1985"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215185",
                              "name": "Malabar Parotta",
                              "category": "Parottas",
                              "description": "Serves 1",
                              "imageId": "ldyhzva56ancpx51vbcl",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "23808559",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 31,
                                        "default": 1,
                                        "id": "77096061",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 31,
                                        "id": "77096062",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808559",
                                        "variationId": "77096061"
                                      }
                                    ],
                                    "price": 3100,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835746",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67835746",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67835746",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67835746",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67835746",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67835746",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67835767",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835767",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835767",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835767",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835767",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835767",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835775",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835775",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835775",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835775",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835775",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808559",
                                        "variationId": "77096062"
                                      }
                                    ],
                                    "price": 3100,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67835746",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67835746",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67835746",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67835746",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67835746",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67835746",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67835767",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67835767",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67835767",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67835767",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67835767",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67835767",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67835775",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67835775",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67835775",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67835775",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67835775",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67835746",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835767",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835775",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 3100,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "2884 ratings",
                                  "ratingCountV2": "2884"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215186",
                              "name": "Ceylon Parotta",
                              "category": "Parottas",
                              "description": "Serves 1",
                              "imageId": "ediibdf3gsujqd6ifutq",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "23808578",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 37,
                                        "default": 1,
                                        "id": "77096099",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 37,
                                        "id": "77096100",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808578",
                                        "variationId": "77096099"
                                      }
                                    ],
                                    "price": 3700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67836374",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836374",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836374",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836374",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836374",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808578",
                                        "variationId": "77096100"
                                      }
                                    ],
                                    "price": 3700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67836362",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67836368",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67836374",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836374",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836374",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836374",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836374",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67836362",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836368",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836374",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 3700,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "1017 ratings",
                                  "ratingCountV2": "1017"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215187",
                              "name": "Coin Parotta",
                              "category": "Parottas",
                              "description": "Serves 1",
                              "imageId": "fmfupmuieyd62gfdcddh",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "23808597",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 30,
                                        "default": 1,
                                        "id": "77096135",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 30,
                                        "id": "77096136",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808597",
                                        "variationId": "77096135"
                                      }
                                    ],
                                    "price": 3000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67838847",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838847",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838847",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838847",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838847",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808597",
                                        "variationId": "77096136"
                                      }
                                    ],
                                    "price": 3000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838789",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67838811",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67838847",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838847",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838847",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838847",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838847",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67838789",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838811",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838847",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 3000,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "1804 ratings",
                                  "ratingCountV2": "1804"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215188",
                              "name": "Wheat Parotta",
                              "category": "Parottas",
                              "description": "Serves 1",
                              "imageId": "pcazjlp7ayhpfx6utrfs",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "23808587",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 37,
                                        "default": 1,
                                        "id": "77096115",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 37,
                                        "id": "77096116",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808587",
                                        "variationId": "77096115"
                                      }
                                    ],
                                    "price": 3700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67837637",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67837637",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67837637",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67837637",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67837637",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67837637",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67837672",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67837672",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67837672",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67837672",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67837672",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67837672",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67837698",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67837698",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67837698",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67837698",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67837698",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808587",
                                        "variationId": "77096116"
                                      }
                                    ],
                                    "price": 3700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67837637",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67837637",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67837637",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67837637",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67837637",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67837637",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67837672",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67837672",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67837672",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67837672",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67837672",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67837672",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67837698",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67837698",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67837698",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67837698",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67837698",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67837637",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67837672",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67837698",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 3700,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "826 ratings",
                                  "ratingCountV2": "826"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215190",
                              "name": "Onion Parotta",
                              "category": "Parottas",
                              "description": "Serves 1",
                              "imageId": "myyuewcas7lpkmujnznr",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6100,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "47 ratings",
                                  "ratingCountV2": "47"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215192",
                              "name": "Empire Butter Parotta",
                              "category": "Parottas",
                              "description": "Serves 1",
                              "imageId": "alnvnbfhdf1zaw3js35b",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "23808592",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 46,
                                        "default": 1,
                                        "id": "77096125",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 46,
                                        "id": "77096126",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808592",
                                        "variationId": "77096125"
                                      }
                                    ],
                                    "price": 4600,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838131",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838131",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838131",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838131",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838131",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838131",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838144",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67838144",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67838144",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67838144",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67838144",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67838144",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67838152",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838152",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838152",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838152",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838152",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808592",
                                        "variationId": "77096126"
                                      }
                                    ],
                                    "price": 4600,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838131",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838131",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838131",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838131",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838131",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838131",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838144",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67838144",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67838144",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67838144",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67838144",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67838144",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67838152",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838152",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838152",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838152",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838152",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67838131",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838144",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838152",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 4600,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "65 ratings",
                                  "ratingCountV2": "65"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822589",
                              "name": "Ghee Chapathi",
                              "category": "Parottas",
                              "description": "Serves 1",
                              "imageId": "qsdkgx5pnq02wplrjoet",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "23808585",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 33,
                                        "default": 1,
                                        "id": "77096111",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 33,
                                        "id": "77096112",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808585",
                                        "variationId": "77096111"
                                      }
                                    ],
                                    "price": 3300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67837531",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67837531",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67837531",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67837531",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67837531",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67837531",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67837547",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67837547",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67837547",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67837547",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67837547",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67837547",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67837556",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67837556",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67837556",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67837556",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67837556",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808585",
                                        "variationId": "77096112"
                                      }
                                    ],
                                    "price": 3300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67837531",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67837531",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67837531",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67837531",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67837531",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67837531",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67837547",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67837547",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67837547",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67837547",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67837547",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67837547",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67837556",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67837556",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67837556",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67837556",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67837556",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67837531",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67837547",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67837556",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 3300,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "86 ratings",
                                  "ratingCountV2": "86"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822629",
                              "name": "Empire Mix Parotta",
                              "category": "Parottas",
                              "description": "Serves 1",
                              "imageId": "obn7o07vyyjjeqwifnsd",
                              "inStock": 1,
                              "price": 19000,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67839129",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839139",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839151",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "36 ratings",
                                  "ratingCountV2": "36"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822632",
                              "name": "Empire Special Porota",
                              "category": "Parottas",
                              "description": "Serves 1",
                              "imageId": "bvctwoc4xuwlpwwe1bif",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "23808606",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 50,
                                        "default": 1,
                                        "id": "77096153",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 50,
                                        "id": "77096154",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808606",
                                        "variationId": "77096153"
                                      }
                                    ],
                                    "price": 5000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67839504",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67839504",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67839504",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67839504",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67839504",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67839504",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67839520",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67839520",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67839520",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67839520",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67839520",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67839520",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67839535",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839535",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839535",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839535",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839535",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23808606",
                                        "variationId": "77096154"
                                      }
                                    ],
                                    "price": 5000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67839504",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67839504",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67839504",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67839504",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67839504",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67839504",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67839520",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67839520",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67839520",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67839520",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67839520",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67839520",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67839535",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839535",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839535",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839535",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839535",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67839504",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839520",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839535",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 5000,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "178 ratings",
                                  "ratingCountV2": "178"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Rotis",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215171",
                              "name": "Tandoori Roti",
                              "category": "Rotis",
                              "description": "Serves 1",
                              "imageId": "w3yfetb1zmaa7yawvmbg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3200,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67837261",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67837273",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67837281",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "810 ratings",
                                  "ratingCountV2": "810"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215173",
                              "name": "Butter Roti",
                              "category": "Rotis",
                              "description": "Serves 1",
                              "imageId": "svkp2zkf11nyaz7w6vs1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3600,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67836402",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836415",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836422",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "281 ratings",
                                  "ratingCountV2": "281"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215175",
                              "name": "Kulcha",
                              "category": "Rotis",
                              "description": "Serves 1",
                              "imageId": "bzdjx3rqgccz6iuyyk0b",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "24090406",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 35,
                                        "default": 1,
                                        "id": "77727447",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 35,
                                        "id": "77727448",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "24090406",
                                        "variationId": "77727447"
                                      }
                                    ],
                                    "price": 3500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67839103",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839103",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839103",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839103",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839103",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "24090406",
                                        "variationId": "77727448"
                                      }
                                    ],
                                    "price": 3500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67839052",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67839089",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67839103",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839103",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839103",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839103",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839103",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67839052",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839089",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839103",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 3500,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "1067 ratings",
                                  "ratingCountV2": "1067"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215176",
                              "name": "Tandoori Naan",
                              "category": "Rotis",
                              "description": "Serves 1",
                              "imageId": "mq1wvypya46dahpmedir",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "24090400",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 35,
                                        "default": 1,
                                        "id": "77727435",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 35,
                                        "id": "77727436",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "24090400",
                                        "variationId": "77727435"
                                      }
                                    ],
                                    "price": 3500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838177",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838177",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838177",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838177",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838177",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838177",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838207",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67838207",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67838207",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67838207",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67838207",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67838207",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67838216",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838216",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838216",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838216",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838216",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "24090400",
                                        "variationId": "77727436"
                                      }
                                    ],
                                    "price": 3500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838177",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838177",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838177",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838177",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838177",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838177",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838207",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67838207",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67838207",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67838207",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67838207",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67838207",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67838216",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838216",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838216",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838216",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838216",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67838177",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838207",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838216",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 3500,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "365 ratings",
                                  "ratingCountV2": "365"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215177",
                              "name": "Butter Naan",
                              "category": "Rotis",
                              "description": "Serves 1",
                              "imageId": "kpzbzfamrpnqune4nxn6",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "24090407",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 45,
                                        "default": 1,
                                        "id": "77727449",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 45,
                                        "id": "77727450",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "24090407",
                                        "variationId": "77727449"
                                      }
                                    ],
                                    "price": 4500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67839310",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67839310",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67839310",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67839310",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67839310",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67839310",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67839343",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67839343",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67839343",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67839343",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67839343",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67839343",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67839371",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839371",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839371",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839371",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839371",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "24090407",
                                        "variationId": "77727450"
                                      }
                                    ],
                                    "price": 4500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67839310",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67839310",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67839310",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67839310",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67839310",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67839310",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67839343",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67839343",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67839343",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67839343",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67839343",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67839343",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67839371",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839371",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839371",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839371",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839371",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67839310",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839343",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839371",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 4500,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1149 ratings",
                                  "ratingCountV2": "1149"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "1395450",
                              "name": "Butter Kulcha",
                              "category": "Rotis",
                              "description": "Serves 1",
                              "imageId": "thbj92jjhbmctknwaqnh",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "24090387",
                                    "name": "Complementary",
                                    "variations": [
                                      {
                                        "name": "Complementary Dal",
                                        "price": 45,
                                        "default": 1,
                                        "id": "77727410",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Complementary Red Gravy",
                                        "price": 45,
                                        "id": "77727411",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "24090387",
                                        "variationId": "77727410"
                                      }
                                    ],
                                    "price": 4500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67837159",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67837159",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67837159",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67837159",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67837159",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67837159",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67837167",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67837167",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67837167",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67837167",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67837167",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67837167",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67837185",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67837185",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67837185",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67837185",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67837185",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "24090387",
                                        "variationId": "77727411"
                                      }
                                    ],
                                    "price": 4500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67837159",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67837159",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67837159",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67837159",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67837159",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67837159",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67837167",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67837167",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67837167",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67837167",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67837167",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67837167",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67837185",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67837185",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67837185",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67837185",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67837185",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67837159",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67837167",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67837185",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 4500,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "157 ratings",
                                  "ratingCountV2": "157"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "North Indian Veg (gravy)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79335727",
                              "name": "Tawa Paneer",
                              "category": "North Indian Veg (gravy)",
                              "description": "Serves 1",
                              "imageId": "nlfkcvfulkz0iionu9om",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20300,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67842693",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842717",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842746",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79335728",
                              "name": "Tawa Veg",
                              "category": "North Indian Veg (gravy)",
                              "description": "Serves 1",
                              "imageId": "k1bsgnny2kert0wxj8ab",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20300,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67842770",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842776",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67842802",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822560",
                              "name": "Kadai Veg",
                              "category": "North Indian Veg (gravy)",
                              "description": "Serves 1",
                              "imageId": "s3wwjyfhrp5fgcmajdjr",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13800,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "68923548",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836618",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836629",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836637",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "50 ratings",
                                  "ratingCountV2": "50"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822622",
                              "name": "Kadai Paneer",
                              "category": "North Indian Veg (gravy)",
                              "description": "Serves 1",
                              "imageId": "bxxarwcannwouaouy3os",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810893",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 240,
                                        "id": "18814042",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 133,
                                        "default": 1,
                                        "id": "18814041",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810893",
                                        "variationId": "18814042"
                                      }
                                    ],
                                    "price": 24000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923684",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67838548",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67838548",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67838548",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67838552",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838552",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838552",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838552",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838552",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838552",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838573",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838573",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838573",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838573",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838573",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810893",
                                        "variationId": "18814041"
                                      }
                                    ],
                                    "price": 13300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923684",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67838548",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67838548",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67838548",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67838552",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838552",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838552",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838552",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838552",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838552",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838573",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838573",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838573",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838573",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838573",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923684",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838548",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838552",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838573",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 13300,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "105 ratings",
                                  "ratingCountV2": "105"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Desserts",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "83973556",
                              "name": "Tender Coconut Pudding",
                              "category": "Desserts",
                              "description": "Serves 1 | A refreshing delight with delicate flavors made from tender coconut, all set to melt in your mouth.(100gms)",
                              "imageId": "kfjnsxwv02iiquqaykvc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7100,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67842866",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "357 ratings",
                                  "ratingCountV2": "357"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Egg Item",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822495",
                              "name": "Egg Burji",
                              "category": "Egg Item",
                              "description": "Serves 1",
                              "imageId": "cg5s6kzlpaunkh8fplua",
                              "inStock": 1,
                              "price": 8200,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "88 ratings",
                                  "ratingCountV2": "88"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822484",
                              "name": "Egg Bulls Eye",
                              "category": "Egg Item",
                              "description": "Serves 1",
                              "imageId": "fryhh8spfxlbiwtamjgp",
                              "inStock": 1,
                              "price": 5100,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "28 ratings",
                                  "ratingCountV2": "28"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822497",
                              "name": "Spl Dal Fry With Egg",
                              "category": "Egg Item",
                              "description": "Serves 1",
                              "imageId": "auuwpssammnfjaocpuam",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810792",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 258,
                                        "id": "18813759",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 143,
                                        "default": 1,
                                        "id": "18813758",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810792",
                                        "variationId": "18813759"
                                      }
                                    ],
                                    "price": 25800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923338",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67835471",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67835471",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67835471",
                                        "addonId": "54156418"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810792",
                                        "variationId": "18813758"
                                      }
                                    ],
                                    "price": 14300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923338",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67835471",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67835471",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67835471",
                                        "addonId": "54156418"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923338",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835471",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 14300,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "37 ratings",
                                  "ratingCountV2": "37"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215092",
                              "name": "Egg Omelette",
                              "category": "Egg Item",
                              "description": "Serves 1",
                              "imageId": "mkh1a6yrfor6cqvr1tua",
                              "inStock": 1,
                              "price": 8200,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "121 ratings",
                                  "ratingCountV2": "121"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822649",
                              "name": "Boiled Egg (2 Nos)",
                              "category": "Egg Item",
                              "description": "Serves 1",
                              "imageId": "ruywk7pf1yvmzeb9jnv3",
                              "inStock": 1,
                              "price": 4100,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67840216",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "32 ratings",
                                  "ratingCountV2": "32"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Empire Special Tawa Dishes",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822506",
                              "name": "Fiery Basa Fish Fillet",
                              "category": "Empire Special Tawa Dishes",
                              "description": "Serves 1",
                              "imageId": "cmbtminwmsomjsaxmad4",
                              "inStock": 1,
                              "price": 35500,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67835720",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835726",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "49 ratings",
                                  "ratingCountV2": "49"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822533",
                              "name": "Hot Chilly Prawns (tawa Fry)",
                              "category": "Empire Special Tawa Dishes",
                              "description": "Serves 1",
                              "imageId": "w0ryzceyck4utca3l9pf",
                              "inStock": 1,
                              "price": 36200,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67835979",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835986",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "66 ratings",
                                  "ratingCountV2": "66"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822635",
                              "name": "Fiery Chicken Wings",
                              "category": "Empire Special Tawa Dishes",
                              "description": "Serves 1",
                              "imageId": "pw9oczdrdjeeos8zxwn2",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810904",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 500,
                                        "id": "18814073",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 270,
                                        "id": "18814072",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 145,
                                        "default": 1,
                                        "id": "28135464",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810904",
                                        "variationId": "18814073"
                                      }
                                    ],
                                    "price": 50000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67839669",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67839669",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67839669",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67839674",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839674",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839674",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839674",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839674",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810904",
                                        "variationId": "18814072"
                                      }
                                    ],
                                    "price": 27000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67839669",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67839669",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67839669",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67839674",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839674",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839674",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839674",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839674",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810904",
                                        "variationId": "28135464"
                                      }
                                    ],
                                    "price": 14500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67839669",
                                        "addonId": "54156436"
                                      },
                                      {
                                        "groupId": "67839669",
                                        "addonId": "54156437"
                                      },
                                      {
                                        "groupId": "67839669",
                                        "addonId": "54156438"
                                      },
                                      {
                                        "groupId": "67839674",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67839674",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67839674",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67839674",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67839674",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67839669",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839674",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 14500,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "297 ratings",
                                  "ratingCountV2": "297"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Fried Rice & Noodles",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215228",
                              "name": "Prawns Fried Rice",
                              "category": "Fried Rice & Noodles",
                              "description": "Serves 1",
                              "imageId": "csop6sf3zuvis19txy7q",
                              "inStock": 1,
                              "price": 24500,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67840628",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67840658",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "64 ratings",
                                  "ratingCountV2": "64"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215224",
                              "name": "Egg Fried Rice",
                              "category": "Fried Rice & Noodles",
                              "description": "Serves 1",
                              "imageId": "vretzm7ieccmpf28g4oh",
                              "inStock": 1,
                              "price": 19400,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67838357",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838381",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "418 ratings",
                                  "ratingCountV2": "418"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215223",
                              "name": "Veg Fried Rice",
                              "category": "Fried Rice & Noodles",
                              "description": "Serves 1",
                              "imageId": "vvpigujlw9jyfbtt2xxa",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18400,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67836131",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836150",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "386 ratings",
                                  "ratingCountV2": "386"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215225",
                              "name": "Chicken Fried Rice",
                              "category": "Fried Rice & Noodles",
                              "description": "Serves 1",
                              "imageId": "pkoi9cfitwisdevisr7v",
                              "inStock": 1,
                              "price": 21400,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67840112",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67840153",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "742 ratings",
                                  "ratingCountV2": "742"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215226",
                              "name": "Mutton Fried Rice",
                              "category": "Fried Rice & Noodles",
                              "description": "Serves 1",
                              "imageId": "uocn0xa0orusb0hitvqw",
                              "inStock": 1,
                              "price": 24500,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67835071",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835074",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "65 ratings",
                                  "ratingCountV2": "65"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822651",
                              "name": "Mix Fried Rice Non Veg",
                              "category": "Fried Rice & Noodles",
                              "description": "Serves 1",
                              "imageId": "nhyk8elhcalzcdybca75",
                              "inStock": 1,
                              "price": 23500,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67840241",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67840275",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "38 ratings",
                                  "ratingCountV2": "38"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Shawarma",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822681",
                              "name": "Tawa Shawarma",
                              "category": "Shawarma",
                              "description": "Serves 1",
                              "imageId": "lknei9tpqykfvudty8ax",
                              "inStock": 1,
                              "price": 16200,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "72802152",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1184 ratings",
                                  "ratingCountV2": "1184"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "1794387",
                              "name": "Chicken Shawarma",
                              "category": "Shawarma",
                              "description": "Serves 1",
                              "imageId": "fbtsm6ejxytccvjbjf4l",
                              "inStock": 1,
                              "price": 9000,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67839459",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839468",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "4582 ratings",
                                  "ratingCountV2": "4582"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "North Indian Non Veg (gravy)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215113",
                              "name": "Kadai Chicken Gravy",
                              "category": "North Indian Non Veg (gravy)",
                              "description": "Serves 1",
                              "imageId": "sw1jachllyur2m1eew2c",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "9996806",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 490,
                                        "id": "33010918",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 255,
                                        "id": "33010919",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 143,
                                        "default": 1,
                                        "id": "33010920",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "9996806",
                                        "variationId": "33010918"
                                      }
                                    ],
                                    "price": 49000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923698",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67838631",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67838631",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67838631",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67838645",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838645",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838645",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838645",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838645",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838645",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838678",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838678",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838678",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838678",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838678",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "9996806",
                                        "variationId": "33010919"
                                      }
                                    ],
                                    "price": 25500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923698",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67838631",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67838631",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67838631",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67838645",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838645",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838645",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838645",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838645",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838645",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838678",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838678",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838678",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838678",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838678",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "9996806",
                                        "variationId": "33010920"
                                      }
                                    ],
                                    "price": 14300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923698",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67838631",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67838631",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67838631",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67838645",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838645",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838645",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838645",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838645",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838645",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838678",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838678",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838678",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838678",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838678",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923698",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838631",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838645",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838678",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 14300,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "271 ratings",
                                  "ratingCountV2": "271"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822621",
                              "name": "Hyderabadi Chicken Boneless Gravy",
                              "category": "North Indian Non Veg (gravy)",
                              "description": "Serves 1",
                              "imageId": "vjzytwcf9qrj6mjqm0hh",
                              "inStock": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810891",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 500,
                                        "id": "18814037",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 265,
                                        "id": "18814036",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 153,
                                        "default": 1,
                                        "id": "18814035",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810891",
                                        "variationId": "18814037"
                                      }
                                    ],
                                    "price": 50000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923672",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67838478",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67838478",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67838478",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67838496",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838496",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838496",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838496",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838496",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838496",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838519",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838519",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838519",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838519",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838519",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810891",
                                        "variationId": "18814036"
                                      }
                                    ],
                                    "price": 26500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923672",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67838478",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67838478",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67838478",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67838496",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838496",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838496",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838496",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838496",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838496",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838519",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838519",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838519",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838519",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838519",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810891",
                                        "variationId": "18814035"
                                      }
                                    ],
                                    "price": 15300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923672",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67838478",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67838478",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67838478",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67838496",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838496",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838496",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838496",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838496",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838496",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838519",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838519",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838519",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838519",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838519",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923672",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838478",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838496",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838519",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 15300,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "55 ratings",
                                  "ratingCountV2": "55"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Salads",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117673923",
                              "name": "Mini Salad",
                              "category": "Salads",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3500,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Soup",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215004",
                              "name": "Chicken Clear Soup",
                              "category": "Soup",
                              "inStock": 1,
                              "price": 9100,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67840602",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "183 ratings",
                                  "ratingCountV2": "183"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "24685892",
                              "name": "Lemon Coriander Chicken Soup",
                              "category": "Soup",
                              "inStock": 1,
                              "price": 9100,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67837574",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "86 ratings",
                                  "ratingCountV2": "86"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Veg Dry",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822592",
                              "name": "Pappad",
                              "category": "Veg Dry",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2000,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "50 ratings",
                                  "ratingCountV2": "50"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215007",
                              "name": "Gobi Manchurian",
                              "category": "Veg Dry",
                              "description": "Serves 1",
                              "imageId": "rsis0nq4bvjiu2g7ncks",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810882",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 174,
                                        "id": "18814010",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 97,
                                        "default": 1,
                                        "id": "18814009",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810882",
                                        "variationId": "18814010"
                                      }
                                    ],
                                    "price": 17400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838240",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67838240",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67838240",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67838240",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67838240",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67838240",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67838247",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838247",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838247",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838247",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838247",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810882",
                                        "variationId": "18814009"
                                      }
                                    ],
                                    "price": 9700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67838240",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67838240",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67838240",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67838240",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67838240",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67838240",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67838247",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838247",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838247",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838247",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838247",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67838240",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838247",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 9700,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "977 ratings",
                                  "ratingCountV2": "977"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822582",
                              "name": "Paneer Chilly Dry",
                              "category": "Veg Dry",
                              "description": "Serves 1",
                              "imageId": "j1kkkv5uzgtbtgnwexkr",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810862",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 179,
                                        "id": "18813956",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 102,
                                        "default": 1,
                                        "id": "18813955",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810862",
                                        "variationId": "18813956"
                                      }
                                    ],
                                    "price": 17900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67837200",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67837200",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67837200",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67837200",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67837200",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67837200",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67837210",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67837210",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67837210",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67837210",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67837210",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810862",
                                        "variationId": "18813955"
                                      }
                                    ],
                                    "price": 10200,
                                    "addonCombinations": [
                                      {
                                        "groupId": "67837200",
                                        "addonId": "54156457"
                                      },
                                      {
                                        "groupId": "67837200",
                                        "addonId": "54156458"
                                      },
                                      {
                                        "groupId": "67837200",
                                        "addonId": "54156459"
                                      },
                                      {
                                        "groupId": "67837200",
                                        "addonId": "54156460"
                                      },
                                      {
                                        "groupId": "67837200",
                                        "addonId": "54156461"
                                      },
                                      {
                                        "groupId": "67837200",
                                        "addonId": "54156462"
                                      },
                                      {
                                        "groupId": "67837210",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67837210",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67837210",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67837210",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67837210",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "67837200",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67837210",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 10200,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "112 ratings",
                                  "ratingCountV2": "112"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Veg Gravy",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822563",
                              "name": "Raitha",
                              "category": "Veg Gravy",
                              "description": "Serves 1",
                              "imageId": "pxfpgtc5od4wnvqtqlgk",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3500,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67836658",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836663",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836673",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "28 ratings",
                                  "ratingCountV2": "28"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822661",
                              "name": "Dal Tadka",
                              "category": "Veg Gravy",
                              "description": "Serves 1",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810926",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 237,
                                        "id": "18814133",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "price": 128,
                                        "id": "18814132",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 77,
                                        "default": 1,
                                        "id": "18814131",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810926",
                                        "variationId": "18814133"
                                      }
                                    ],
                                    "price": 23700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923954",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67840942",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67840942",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67840942",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67840950",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67840950",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67840950",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67840950",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67840950",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67840950",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67840979",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67840979",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67840979",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67840979",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67840979",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810926",
                                        "variationId": "18814132"
                                      }
                                    ],
                                    "price": 12800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923954",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67840942",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67840942",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67840942",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67840950",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67840950",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67840950",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67840950",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67840950",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67840950",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67840979",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67840979",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67840979",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67840979",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67840979",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810926",
                                        "variationId": "18814131"
                                      }
                                    ],
                                    "price": 7700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923954",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67840942",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67840942",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67840942",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67840950",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67840950",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67840950",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67840950",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67840950",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67840950",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67840979",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67840979",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67840979",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67840979",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67840979",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923954",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67840942",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67840950",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67840979",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 7700,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "119 ratings",
                                  "ratingCountV2": "119"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215089",
                              "name": "Dal Fry",
                              "category": "Veg Gravy",
                              "description": "Serves 1",
                              "imageId": "jxxtujwekfghedg6axk1",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810896",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 122,
                                        "id": "18814050",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 71,
                                        "default": 1,
                                        "id": "18814049",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810896",
                                        "variationId": "18814050"
                                      }
                                    ],
                                    "price": 12200,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923715",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67838709",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67838709",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67838709",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838750",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838750",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838750",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838750",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838750",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810896",
                                        "variationId": "18814049"
                                      }
                                    ],
                                    "price": 7100,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923715",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67838709",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67838709",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67838709",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67838720",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67838750",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67838750",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67838750",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67838750",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67838750",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923715",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838709",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838720",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67838750",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 7100,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "1319 ratings",
                                  "ratingCountV2": "1319"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215084",
                              "name": "Paneer Butter Masala",
                              "category": "Veg Gravy",
                              "description": "Serves 1",
                              "imageId": "aebk3ggsozr3gtijronv",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810851",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 189,
                                        "id": "18813925",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 112,
                                        "default": 1,
                                        "id": "18813924",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810851",
                                        "variationId": "18813925"
                                      }
                                    ],
                                    "price": 18900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923559",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67836806",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67836806",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67836806",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67836847",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836847",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836847",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836847",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836847",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810851",
                                        "variationId": "18813924"
                                      }
                                    ],
                                    "price": 11200,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68923559",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67836806",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67836806",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67836806",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67836836",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67836847",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836847",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836847",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836847",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836847",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68923559",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836806",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836836",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836847",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 11200,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "2157 ratings",
                                  "ratingCountV2": "2157"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822555",
                              "name": "Veg Kurma",
                              "category": "Veg Gravy",
                              "description": "Serves 1",
                              "imageId": "aabyscimg5b0yyf4k4yu",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {},
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "5810837",
                                    "name": "Portion ",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 148,
                                        "id": "18813886",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Qtr",
                                        "price": 87,
                                        "default": 1,
                                        "id": "18813885",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810837",
                                        "variationId": "18813886"
                                      }
                                    ],
                                    "price": 14800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68924583",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67836466",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67836466",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67836466",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67836496",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67836496",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67836496",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67836496",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67836496",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67836496",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67836512",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836512",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836512",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836512",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836512",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "5810837",
                                        "variationId": "18813885"
                                      }
                                    ],
                                    "price": 8700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "68924583",
                                        "addonId": "54935012"
                                      },
                                      {
                                        "groupId": "67836466",
                                        "addonId": "54156416"
                                      },
                                      {
                                        "groupId": "67836466",
                                        "addonId": "54156417"
                                      },
                                      {
                                        "groupId": "67836466",
                                        "addonId": "54156418"
                                      },
                                      {
                                        "groupId": "67836496",
                                        "addonId": "54156419"
                                      },
                                      {
                                        "groupId": "67836496",
                                        "addonId": "54156420"
                                      },
                                      {
                                        "groupId": "67836496",
                                        "addonId": "54156421"
                                      },
                                      {
                                        "groupId": "67836496",
                                        "addonId": "54156422"
                                      },
                                      {
                                        "groupId": "67836496",
                                        "addonId": "54156423"
                                      },
                                      {
                                        "groupId": "67836496",
                                        "addonId": "54156424"
                                      },
                                      {
                                        "groupId": "67836512",
                                        "addonId": "54156425"
                                      },
                                      {
                                        "groupId": "67836512",
                                        "addonId": "54156426"
                                      },
                                      {
                                        "groupId": "67836512",
                                        "addonId": "54156427"
                                      },
                                      {
                                        "groupId": "67836512",
                                        "addonId": "54156428"
                                      },
                                      {
                                        "groupId": "67836512",
                                        "addonId": "54156429"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "68924583",
                                  "groupName": "Rice",
                                  "choices": [
                                    {
                                      "id": "54935012",
                                      "name": "Ghee Rice",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836466",
                                  "groupName": "Parotta",
                                  "choices": [
                                    {
                                      "id": "54156417",
                                      "name": "Empire Spl Parotta",
                                      "price": 4700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156416",
                                      "name": "Coin Paroatta",
                                      "price": 2700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156418",
                                      "name": "Kerala Parotta",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836496",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836512",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 8700,
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.1",
                                  "ratingCount": "44 ratings",
                                  "ratingCountV2": "44"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Juice Shop",
                      "categories": [
                        {
                          "title": "Lychee Fest",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120688145",
                                  "name": "Lychee Malba",
                                  "category": "Juice Shop",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14300,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {}
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120688146",
                                  "name": "Lychee Thickshake",
                                  "category": "Juice Shop",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 13200,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {}
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120688147",
                                  "name": "Lychee Falooda",
                                  "category": "Juice Shop",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {}
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120688148",
                                  "name": "Lady Lychee",
                                  "category": "Juice Shop",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 9900,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {}
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Falooda",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "86519299",
                                  "name": "Empire Special Falooda",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | This Signature Falooda is made with fresh cut pieces of Kiwi and Bananas mixed together with our special homemade rose milk mixture and a combination of jelly, poppy seeds, vermicelli, cereals and dry fruit mixture that is all topped off with rainbow ice cream and red cherry.",
                                  "imageId": "ogahlaofpbpzwrcot0n6",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "22 ratings",
                                      "ratingCountV2": "22"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "86519302",
                                  "name": "Tender Coconut Falooda",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | For those with a sweet tooth, the Tender Falooda Ice Cream is a delicious treat. This traditional dessert is made with tender coconut flavors combined with layers of jelly, poppy seeds, vermicelli, dry fruit mixture, and topped with red cherry.",
                                  "imageId": "ccfzjuihtwly6azwyvyo",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 18700,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "15 ratings",
                                      "ratingCountV2": "15"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "28308865",
                                  "name": "Bombay Falooda",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | This Falooda is our interpretation of the classical Bombay style Falooda. Made from special homemade rose milk mix combined with layers of jelly, poppy seeds, vermicelli, dry fruit mixture, and topped with red cherry.",
                                  "imageId": "r6rf3osd6glvxzj7p0d7",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 15400,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "193 ratings",
                                      "ratingCountV2": "193"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "28309643",
                                  "name": "Kulfi Falooda",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | Treat yourself to a little indulgence with our Kulfi Ice Cream Falooda. Topped with Rich Malai Kulfi Ice Cream combined with layers of jelly, poppy seeds, vermicelli and dry fruit mixture, . It's the perfect end to any meal.",
                                  "imageId": "ehwvo8dhazsxoslkfb9s",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 15400,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "144 ratings",
                                      "ratingCountV2": "144"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "28309677",
                                  "name": "Rabdi Falooda",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | Rabdi Falooda Ice Cream is an enticing and mouthwatering dessert. It has a delicious taste that is simply appetizing. This dessert is prepared using homemade rabadi, poppy seeds, vermicelli, ice cream, dry fruit mixture topped with red cherry.",
                                  "imageId": "lbdoyqirtmggsxfag7z5",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 15400,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "149 ratings",
                                      "ratingCountV2": "149"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Chocolate Fest",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "104035812",
                                  "name": "Chocolate Mousse",
                                  "category": "Juice Shop",
                                  "description": "Serves 1",
                                  "imageId": "rkufmtlhzq2ufiuqs5on",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 7500,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "104035813",
                                  "name": "Hot Chocolate Fudge",
                                  "category": "Juice Shop",
                                  "description": "Serves 1",
                                  "imageId": "l6sxj0dmltdp1yaoeaym",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14500,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "28309444",
                                  "name": "Death By Chocolate",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | DBC is everyone’s favourite. Scoops of rich and creamy vanilla ice cream with of a warm homemade chocolate cake sponge, drizzled with our signature homemade DBC sauce and roasted peanuts is an absolute treat for every dessert lover.",
                                  "imageId": "lvhxynldslndyn4u02ma",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16500,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.1",
                                      "ratingCount": "42 ratings",
                                      "ratingCountV2": "42"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Desserts & Sundaes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "86519416",
                                  "name": "Mudpot",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | Indulge your sweet tooth with this heavenly dessert. It's made of vanilla custard with bits of chocolate cake sponge, chocolate sauce, dry fruits and topped with rich and creamy scoop of vanilla ice cream.",
                                  "imageId": "irvle0rfgkcsnjrzaykf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14300,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "86519419",
                                  "name": "Red Velvet Pot",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | A melt in mouth Red Velvet Pot made with red velvet cake sponge, a layer of luscious fruit custard topped with scoop of strawberry ice cream.",
                                  "imageId": "zwkm2liumpaxeo73unz6",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14300,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.5",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "86519441",
                                  "name": "Fruit Custard",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | A delightful change in your regular fruit salad. Made with the freshest seasonal fruits and crowned with layers vanilla and strawberry custard.",
                                  "imageId": "x2nmqlzuckjqdvqpjjx2",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 10450,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "20 ratings",
                                      "ratingCountV2": "20"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "28309455",
                                  "name": "Banoffee Sundae",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | Sweet and nutty, this banana sundae features our creamy butterscotch ice cream with caramelized powdered nuts, bananas, and a drizzle of honey.",
                                  "imageId": "xyzo6bnmzc1aspobpmbo",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 15400,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "47822550",
                                  "name": "Arabian Dry Fruit Sundae",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | Enjoy this royal treat of sundae made from combination of chocolate, butterscotch and fig ice cream. it's topped with chocolate sauce, cereals and dry fruits.",
                                  "imageId": "ruf8nsri8m5igsex3yvv",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 17600,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "47822607",
                                  "name": "Fruit Salad With Vanilla Ice Cream",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | You’ll love this Fruit Salad with Ice Cream! It is made with freshly cut tropical fruits that are then mixed with pure honey. To finish it off, we top it with a scoop of rich vanilla and strawberry ice cream. This sweet treat is the perfect way to complete your meal.",
                                  "imageId": "jgrrpdkpqkg89mhzz9cy",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 12100,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "47 ratings",
                                      "ratingCountV2": "47"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "86519396",
                                  "name": "Gudbud",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | A refreshing combination scoops of Vanilla, Strawberry and Mango Ice Creams. With every bite you will experience the flavor adventures of fresh fruit salad and dry fruits. Because our Gudbud isn't just a treat, it's an experience.",
                                  "imageId": "awmh6lks9jjpdtdxcqfj",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14300,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "18 ratings",
                                      "ratingCountV2": "18"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Empire Special Thick Shakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "86519287",
                                  "name": "Fig (Anjeer)Thick Shakes",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | Boasting a delightfully creamy and luxurious texture, our Anjeer Thick shake is a treat for all your senses. You'll love the distinctive flavour of figs, ice cold milk, chocolate sauce, and velvety ice cream.",
                                  "imageId": "qlwu3dhy80nvz5ny4nhr",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685340",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 99,
                                            "default": 1,
                                            "id": "71452913",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 290,
                                            "id": "71452914",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685340",
                                            "variationId": "71452913"
                                          }
                                        ],
                                        "price": 9900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685340",
                                            "variationId": "71452914"
                                          }
                                        ],
                                        "price": 29000
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 9900,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "13 ratings",
                                      "ratingCountV2": "13"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "86519297",
                                  "name": "Chocolate Thick Shake",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | Made with rich chocolate flavour ice cream and syrup, and blended with chilled milk and crushed ice cubes, this thick shake is a choco-lover’s dream.",
                                  "imageId": "pf4dqma3zk99y0qbmkcf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685342",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 88,
                                            "default": 1,
                                            "id": "71452917",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 255,
                                            "id": "71452918",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685342",
                                            "variationId": "71452917"
                                          }
                                        ],
                                        "price": 8800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685342",
                                            "variationId": "71452918"
                                          }
                                        ],
                                        "price": 25500
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 8800,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "23 ratings",
                                      "ratingCountV2": "23"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "96906011",
                                  "name": "Avocado Thick Shake",
                                  "category": "Juice Shop",
                                  "description": "Serves 1",
                                  "imageId": "pxyhxnyqzsqrfrddomo6",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 13500,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "14 ratings",
                                      "ratingCountV2": "14"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "103547845",
                                  "name": "Strawberry Thick Shake",
                                  "category": "Juice Shop",
                                  "description": "Serves 1",
                                  "imageId": "c9cczsfbshesboawhpxa",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685014",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 88,
                                            "default": 1,
                                            "id": "71452257",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 255,
                                            "id": "71452259",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685014",
                                            "variationId": "71452257"
                                          }
                                        ],
                                        "price": 8800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685014",
                                            "variationId": "71452259"
                                          }
                                        ],
                                        "price": 25500
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 8800,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "103547846",
                                  "name": "Vanilla Thick Shake",
                                  "category": "Juice Shop",
                                  "description": "Serves 1",
                                  "imageId": "ga66rsafo2nekfbppjam",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685016",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 88,
                                            "default": 1,
                                            "id": "71452262",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 255,
                                            "id": "71452263",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685016",
                                            "variationId": "71452262"
                                          }
                                        ],
                                        "price": 8800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685016",
                                            "variationId": "71452263"
                                          }
                                        ],
                                        "price": 25500
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 8800,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.2",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "215259",
                                  "name": "Arabian Dry Fruit",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | Our Arabian Dry Fruit Thick Shake is bursting with flavors. The smooth shake combines ice cream, mango pulp and crunchy dry fruits to make a truly indulgent drink. It’s topped off with chocolate syrup for the perfect combination of sweetness, fruitiness and creaminess.",
                                  "imageId": "ujizbqb5tumbx26gmjaj",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685263",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 165,
                                            "default": 1,
                                            "id": "71452757",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 485,
                                            "id": "71452758",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685263",
                                            "variationId": "71452757"
                                          }
                                        ],
                                        "price": 16500
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685263",
                                            "variationId": "71452758"
                                          }
                                        ],
                                        "price": 48500
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 16500,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "84 ratings",
                                      "ratingCountV2": "84"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "215260",
                                  "name": "Red Velvet Queen",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | Our Red Velvet Queen Shake is a blissful marriage of rich, creamy ice cream, chunks of red velvet sponge and chilled milk topped with strawberry syrup, this thick shake will get your taste buds tingling!",
                                  "imageId": "gzwmxysqktbtir27y7tl",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685082",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 126.5,
                                            "default": 1,
                                            "id": "71452394",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 370.5,
                                            "id": "71452395",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685082",
                                            "variationId": "71452394"
                                          }
                                        ],
                                        "price": 12650
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685082",
                                            "variationId": "71452395"
                                          }
                                        ],
                                        "price": 37050
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 12650,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.8",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "215296",
                                  "name": "Apple Thick Shake",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | Sweet, simple, and seriously good. Fresh apple slices are blended with ice cream and crushed ice cubes before being topped with a drizzle of the 100% pure honey.",
                                  "imageId": "mdbasvaq4y6enw7667wa",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685221",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 99,
                                            "default": 1,
                                            "id": "71452672",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 290,
                                            "id": "71452673",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685221",
                                            "variationId": "71452672"
                                          }
                                        ],
                                        "price": 9900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685221",
                                            "variationId": "71452673"
                                          }
                                        ],
                                        "price": 29000
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 9900,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "45 ratings",
                                      "ratingCountV2": "45"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "215298",
                                  "name": "Dates Thick Shakes",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | Lean back and enjoy the thick goodness of Dates Thick Shake which is blended to perfection using creamy ice cream and chilled milk.",
                                  "imageId": "zjbrmgzznqzprv0eqxkf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685091",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 99,
                                            "default": 1,
                                            "id": "71452412",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 290,
                                            "id": "71452413",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685091",
                                            "variationId": "71452412"
                                          }
                                        ],
                                        "price": 9900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685091",
                                            "variationId": "71452413"
                                          }
                                        ],
                                        "price": 29000
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 9900,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "31 ratings",
                                      "ratingCountV2": "31"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "215301",
                                  "name": "Mango Thick Shakes",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | Relish the rich and luscious mango flavour with the delightful taste of ice cream blended with chilled milk and mango pulp.",
                                  "imageId": "vcatjomn6wq2f7uc5bif",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685327",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 88,
                                            "default": 1,
                                            "id": "71452886",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 255,
                                            "id": "71452887",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685327",
                                            "variationId": "71452886"
                                          }
                                        ],
                                        "price": 8800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685327",
                                            "variationId": "71452887"
                                          }
                                        ],
                                        "price": 25500
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 8800,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "163 ratings",
                                      "ratingCountV2": "163"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "215304",
                                  "name": "Sharjah Thick Shakes",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | Constituted by the best of three - banana, mocha and chocolate syrup - this thick shake will keep you refreshed all day long.",
                                  "imageId": "qutjx0rbupksxw5m5txz",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685329",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 99,
                                            "default": 1,
                                            "id": "71452890",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 290,
                                            "id": "71452891",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685329",
                                            "variationId": "71452890"
                                          }
                                        ],
                                        "price": 9900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685329",
                                            "variationId": "71452891"
                                          }
                                        ],
                                        "price": 29000
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 9900,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.1",
                                      "ratingCount": "66 ratings",
                                      "ratingCountV2": "66"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "86519376",
                                  "name": "Chocolate Splash",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | Delicious, lush and satisfying Chocolate Splash is our specialty thick shake that is blended with rich creamy ice cream, chunks of chocolate cake sponge with cold milk, crushed ice cubes and topped off with chocolate syrup.",
                                  "imageId": "yy7rt105kynal6krzj8u",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685346",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 121,
                                            "default": 1,
                                            "id": "71452925",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 355,
                                            "id": "71452926",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685346",
                                            "variationId": "71452925"
                                          }
                                        ],
                                        "price": 12100
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685346",
                                            "variationId": "71452926"
                                          }
                                        ],
                                        "price": 35500
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 12100,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {}
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "86519382",
                                  "name": "Kit Kat Thick Shake",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | Treat yourself to this rich, thick Kit Kat chocolate shake at Empire Juice Shop. Made with chilled milk and ice cream mixed with crushed Kit Kat and chocolate syrup, you really can't beat this combination!",
                                  "imageId": "sl00qfxotvsasoajelyg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685347",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 137.5,
                                            "default": 1,
                                            "id": "71452927",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 399.5,
                                            "id": "71452928",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685347",
                                            "variationId": "71452927"
                                          }
                                        ],
                                        "price": 13750
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685347",
                                            "variationId": "71452928"
                                          }
                                        ],
                                        "price": 39950
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 13750,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {}
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "86519390",
                                  "name": "Oreo Thick Shake",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | Oreo lovers know the deal. Made with chunks of Oreo Biscuits and a layer of rich, creamy ice cream that is topped off with chocolate syrup, this treat is loved by all.",
                                  "imageId": "s7we1y34hpfywovxabhy",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685348",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 137.5,
                                            "default": 1,
                                            "id": "71452929",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 398.5,
                                            "id": "71452930",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685348",
                                            "variationId": "71452929"
                                          }
                                        ],
                                        "price": 13750
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685348",
                                            "variationId": "71452930"
                                          }
                                        ],
                                        "price": 39850
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 13750,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Cold Press Fresh Juices",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "47822534",
                                  "name": "Musambi Juice",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | 100% Pure Fresh Juices, No Water Added",
                                  "imageId": "omk7dilfhvfqcaekxj7q",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685156",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 88,
                                            "default": 1,
                                            "id": "71452542",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 255,
                                            "id": "71452543",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685156",
                                            "variationId": "71452542"
                                          }
                                        ],
                                        "price": 8800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685156",
                                            "variationId": "71452543"
                                          }
                                        ],
                                        "price": 25500
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 8800,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "131 ratings",
                                      "ratingCountV2": "131"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "47822540",
                                  "name": "Watermelon Juice",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | 100% Pure Fresh Juices, No Water Added",
                                  "imageId": "fvckyewcu6jqz8zzn1ft",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685158",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 77,
                                            "default": 1,
                                            "id": "71452546",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 211,
                                            "id": "71452547",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685158",
                                            "variationId": "71452546"
                                          }
                                        ],
                                        "price": 7700
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685158",
                                            "variationId": "71452547"
                                          }
                                        ],
                                        "price": 21100
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 7700,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "252 ratings",
                                      "ratingCountV2": "252"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "47822640",
                                  "name": "Lime Juice",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | 100% Pure Fresh Juices, No Water Added",
                                  "imageId": "udoijcwgskygmkhlmtvi",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685262",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 55,
                                            "default": 1,
                                            "id": "71452755",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 155,
                                            "id": "71452756",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685262",
                                            "variationId": "71452755"
                                          }
                                        ],
                                        "price": 5500
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685262",
                                            "variationId": "71452756"
                                          }
                                        ],
                                        "price": 15500
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 5500,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "127 ratings",
                                      "ratingCountV2": "127"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "86519251",
                                  "name": "Pulpy Grape juice",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | 100% Pure Fresh Juices, No Water Added",
                                  "imageId": "olvadzot3td2gpamufru",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685339",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 99,
                                            "default": 1,
                                            "id": "71452911",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 267,
                                            "id": "71452912",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685339",
                                            "variationId": "71452911"
                                          }
                                        ],
                                        "price": 9900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685339",
                                            "variationId": "71452912"
                                          }
                                        ],
                                        "price": 26700
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 9900,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "54 ratings",
                                      "ratingCountV2": "54"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Mojitos & Coolers",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "86519344",
                                  "name": "Green Apple Mojito",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | Our Green Apple Mojito is a comforting drink made from muddling fresh lime and fresh mint leaves combined with green apple syrup and chilled soda pour over crushed ice cubes.",
                                  "imageId": "ompoano0xaald9fikep5",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685345",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 99,
                                            "default": 1,
                                            "id": "71452923",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 290,
                                            "id": "71452924",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685345",
                                            "variationId": "71452923"
                                          }
                                        ],
                                        "price": 9900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685345",
                                            "variationId": "71452924"
                                          }
                                        ],
                                        "price": 29000
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 9900,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "215289",
                                  "name": "Lime Soda",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | A refreshing citrus flavored soda made with fresh lime, cooled with chilled soda and mixed with a touch of sugar syrup.",
                                  "imageId": "udoijcwgskygmkhlmtvi",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685013",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 66,
                                            "default": 1,
                                            "id": "71452255",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1ltr",
                                            "price": 202,
                                            "id": "71452256",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685013",
                                            "variationId": "71452255"
                                          }
                                        ],
                                        "price": 6600
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685013",
                                            "variationId": "71452256"
                                          }
                                        ],
                                        "price": 20200
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 6600,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "485 ratings",
                                      "ratingCountV2": "485"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "215291",
                                  "name": "Ginger Lime Soda",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | Ginger-lime soda is infused with the flavour of real ginger and lime, and sweetened sugar syrup.",
                                  "imageId": "hs1ym1gdojov0hqd3x5o",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685216",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 71.5,
                                            "default": 1,
                                            "id": "71452662",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 205,
                                            "id": "71452663",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685216",
                                            "variationId": "71452662"
                                          }
                                        ],
                                        "price": 7150
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685216",
                                            "variationId": "71452663"
                                          }
                                        ],
                                        "price": 20500
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 7150,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "122 ratings",
                                      "ratingCountV2": "122"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "28309058",
                                  "name": "Blue Angel",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | Sip on a bright Blue Angel, a fun drink made with lime juice, sugar syrup, ice slush, soda and Blue Curacao syrup",
                                  "imageId": "pr3ptnuz1yfiy0lsxg32",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685217",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 99,
                                            "default": 1,
                                            "id": "71452664",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 290,
                                            "id": "71452665",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685217",
                                            "variationId": "71452664"
                                          }
                                        ],
                                        "price": 9900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685217",
                                            "variationId": "71452665"
                                          }
                                        ],
                                        "price": 29000
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 9900,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "31 ratings",
                                      "ratingCountV2": "31"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "47822488",
                                  "name": "Blue Lime Soda",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | Lighten up your mood with our Blue lime Soda. Made with blue curac?ao syrup, lemonade and splash of chilled soda water.",
                                  "imageId": "rkz3pwnxd3b3l7satpsa",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8800,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "40 ratings",
                                      "ratingCountV2": "40"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "47822542",
                                  "name": "Lime Mint Cooler",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | This is a cool and refreshing blend of crushed ice cubes, lime juice, mint leaves, and chilled water that is blended together .",
                                  "imageId": "evunfe79jfwckwn2zx2r",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685167",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 71.5,
                                            "default": 1,
                                            "id": "71452564",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 205.5,
                                            "id": "71452565",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685167",
                                            "variationId": "71452564"
                                          }
                                        ],
                                        "price": 7150
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685167",
                                            "variationId": "71452565"
                                          }
                                        ],
                                        "price": 20550
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 7150,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "34 ratings",
                                      "ratingCountV2": "34"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "47822626",
                                  "name": "Mojito Mint",
                                  "category": "Juice Shop",
                                  "description": "Serves 1 | A refreshing classical drink made with muddling lemon wedge and fresh mint leaves and combined with fresh lime juice, chilled soda and crushed ice",
                                  "imageId": "ye7vp7dueayhccb55znv",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21685219",
                                        "name": "Potion",
                                        "variations": [
                                          {
                                            "name": "300ml",
                                            "price": 99,
                                            "default": 1,
                                            "id": "71452668",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1Ltr",
                                            "price": 290,
                                            "id": "71452669",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685219",
                                            "variationId": "71452668"
                                          }
                                        ],
                                        "price": 9900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21685219",
                                            "variationId": "71452669"
                                          }
                                        ],
                                        "price": 29000
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 9900,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "39 ratings",
                                      "ratingCountV2": "39"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "47822672",
                                  "name": "Lassi Sweet",
                                  "category": "Juice Shop",
                                  "description": "Serves 1",
                                  "imageId": "tnh0qj18zqdtpx5neqvc",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 7700,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "41 ratings",
                                      "ratingCountV2": "41"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Kulfis",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "28309278",
                                  "name": "Badam Kulfi",
                                  "category": "Juice Shop",
                                  "description": "Serves 1",
                                  "imageId": "zndmhkekkyowt6bbrzjy",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 7000,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "17 ratings",
                                      "ratingCountV2": "17"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "28309296",
                                  "name": "Pista Kulfi",
                                  "category": "Juice Shop",
                                  "description": "Serves 1",
                                  "imageId": "rngynunellqmkinhe2t4",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 7000,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "27 ratings",
                                      "ratingCountV2": "27"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "100217612",
                                  "name": "Matka Kulfi",
                                  "category": "Juice Shop",
                                  "description": "Serves 1",
                                  "imageId": "knpo2manobuiagemdkib",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8900,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "13 ratings",
                                      "ratingCountV2": "13"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101418733",
                                  "name": "Black Current Kulfi",
                                  "category": "Juice Shop",
                                  "description": "Serves 1",
                                  "imageId": "u5xlpe6jfhjuknzqjlps",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 7000,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101418735",
                                  "name": "Dry Fruits Kulfi",
                                  "category": "Juice Shop",
                                  "description": "Serves 1",
                                  "imageId": "leumcfclqrcwoyregzzy",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 7000,
                                  "variants": {},
                                  "variantsV2": {},
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Scoop Ice Creams",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "28309135",
                                  "name": "Pista Ice Cream",
                                  "category": "Juice Shop",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21698387",
                                        "name": "Scoops",
                                        "variations": [
                                          {
                                            "name": "Single",
                                            "price": 70,
                                            "default": 1,
                                            "id": "71481571",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Double",
                                            "price": 135,
                                            "id": "71481572",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21698387",
                                            "variationId": "71481571"
                                          }
                                        ],
                                        "price": 7000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21698387",
                                            "variationId": "71481572"
                                          }
                                        ],
                                        "price": 13500
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 7000,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {}
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "86519265",
                                  "name": "Fig & Honey",
                                  "category": "Juice Shop",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21698388",
                                        "name": "Scoops",
                                        "variations": [
                                          {
                                            "name": "Single",
                                            "price": 70,
                                            "default": 1,
                                            "id": "71481573",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Double",
                                            "price": 135,
                                            "id": "71481574",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21698388",
                                            "variationId": "71481573"
                                          }
                                        ],
                                        "price": 7000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21698388",
                                            "variationId": "71481574"
                                          }
                                        ],
                                        "price": 13500
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 7000,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {}
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "86519267",
                                  "name": "Butterscotch Ice Cream",
                                  "category": "Juice Shop",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21698389",
                                        "name": "Scoops",
                                        "variations": [
                                          {
                                            "name": "Single",
                                            "price": 70,
                                            "default": 1,
                                            "id": "71481575",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Double",
                                            "price": 135,
                                            "id": "71481576",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21698389",
                                            "variationId": "71481575"
                                          }
                                        ],
                                        "price": 7000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21698389",
                                            "variationId": "71481576"
                                          }
                                        ],
                                        "price": 13500
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 7000,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.0",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "86519270",
                                  "name": "Black Currant Ice Cream",
                                  "category": "Juice Shop",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "21698390",
                                        "name": "Scoops",
                                        "variations": [
                                          {
                                            "name": "Single",
                                            "price": 70,
                                            "default": 1,
                                            "id": "71481577",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Double",
                                            "price": 135,
                                            "id": "71481578",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21698390",
                                            "variationId": "71481577"
                                          }
                                        ],
                                        "price": 7000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "21698390",
                                            "variationId": "71481578"
                                          }
                                        ],
                                        "price": 13500
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 7000,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {}
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "28309026",
                                  "name": "Strawberry Ice Cream",
                                  "category": "Juice Shop",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "6952726",
                                        "name": "Scoops",
                                        "variations": [
                                          {
                                            "name": "Single",
                                            "price": 70,
                                            "default": 1,
                                            "id": "23380925",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Double",
                                            "price": 135,
                                            "id": "23380926",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "6952726",
                                            "variationId": "23380925"
                                          }
                                        ],
                                        "price": 7000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "6952726",
                                            "variationId": "23380926"
                                          }
                                        ],
                                        "price": 13500
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 7000,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.4",
                                      "ratingCount": "34 ratings",
                                      "ratingCountV2": "34"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "47822494",
                                  "name": "Chocolate Ice Cream",
                                  "category": "Juice Shop",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "6952699",
                                        "name": "Scoops",
                                        "variations": [
                                          {
                                            "name": "Single",
                                            "price": 70,
                                            "default": 1,
                                            "id": "23378257",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Double",
                                            "price": 135,
                                            "id": "23378258",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "6952699",
                                            "variationId": "23378257"
                                          }
                                        ],
                                        "price": 7000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "6952699",
                                            "variationId": "23378258"
                                          }
                                        ],
                                        "price": 13500
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 7000,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.3",
                                      "ratingCount": "44 ratings",
                                      "ratingCountV2": "44"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "47822606",
                                  "name": "Vanilla Ice Cream",
                                  "category": "Juice Shop",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {},
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "6952722",
                                        "name": "Scoops",
                                        "variations": [
                                          {
                                            "name": "Single",
                                            "price": 70,
                                            "default": 1,
                                            "id": "23380101",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Double",
                                            "price": 135,
                                            "id": "23380102",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "6952722",
                                            "variationId": "23380101"
                                          }
                                        ],
                                        "price": 7000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "6952722",
                                            "variationId": "23380102"
                                          }
                                        ],
                                        "price": 13500
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 7000,
                                  "ribbon": {},
                                  "type": "ITEM",
                                  "itemBadge": {},
                                  "badgesV2": {},
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "49 ratings",
                                      "ratingCountV2": "49"
                                    }
                                  }
                                },
                                "analytics": {},
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Dosa And Appams",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215201",
                              "name": "Egg Dosa Chicken",
                              "category": "Dosa And Appams",
                              "description": "Serves 1",
                              "price": 15300,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67836004",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835999",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836012",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67836021",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 5 pm, today",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "155 ratings",
                                  "ratingCountV2": "155"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215199",
                              "name": "Egg Dosa",
                              "category": "Dosa And Appams",
                              "description": "Serves 1",
                              "price": 6000,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67891785",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67891786",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67891784",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67891787",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 5 pm, today",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "161 ratings",
                                  "ratingCountV2": "161"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215200",
                              "name": "Dosa Chicken",
                              "category": "Dosa And Appams",
                              "description": "Serves 1",
                              "price": 14300,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67891819",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67891820",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67891818",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67891821",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 5 pm, today",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "450 ratings",
                                  "ratingCountV2": "450"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822489",
                              "name": "Onion Dosa Veg",
                              "category": "Dosa And Appams",
                              "description": "Serves 1",
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67835155",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835149",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835164",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835170",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 5 pm, today",
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822530",
                              "name": "Plain Dosa (single)",
                              "category": "Dosa And Appams",
                              "description": "Serves 1",
                              "isVeg": 1,
                              "price": 3100,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67835892",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835885",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835896",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67835908",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 5 pm, today",
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "62 ratings",
                                  "ratingCountV2": "62"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "215202",
                              "name": "Onion Dosa Chicken",
                              "category": "Dosa And Appams",
                              "description": "Serves 1",
                              "price": 15300,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67840512",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67840506",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67840532",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67840547",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 5 pm, today",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47822639",
                              "name": "Onion Dosa",
                              "category": "Dosa And Appams",
                              "description": "Serves 1",
                              "isVeg": 1,
                              "price": 3600,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "67839709",
                                  "groupName": "Starters",
                                  "choices": [
                                    {
                                      "id": "54156423",
                                      "name": "Paneer Chilly Dry",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156419",
                                      "name": "Empire spl Chicken Kebab (qtr)",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156422",
                                      "name": "Pepper Mutton Dry (Qtr)",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156421",
                                      "name": "Murg Tikka (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156420",
                                      "name": "Chilly Chicken Boneless (qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156424",
                                      "name": "Gobi Manchurian (Qtr)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839704",
                                  "groupName": "Dips",
                                  "choices": [
                                    {
                                      "id": "54156438",
                                      "name": "Mint Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156437",
                                      "name": "Grill Chutney 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156436",
                                      "name": "Mayonnaise 50Ml",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839726",
                                  "groupName": "Gravy",
                                  "choices": [
                                    {
                                      "id": "54156457",
                                      "name": "Butter Chicken Boneless (Qtr)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156460",
                                      "name": "Mutton Varuval (Qtr)",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156459",
                                      "name": "Kadai Chicken (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156462",
                                      "name": "Kadai Veg",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156458",
                                      "name": "Pepper Chicken Masala (Qtr)",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156461",
                                      "name": "Paneer Butter Masala (Qtr)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "67839737",
                                  "groupName": "Beverage / Fresh Juice",
                                  "choices": [
                                    {
                                      "id": "54156429",
                                      "name": "Watermelon Juice",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156428",
                                      "name": "Pulpy Grape Juice",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156427",
                                      "name": "Lime Soda",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156426",
                                      "name": "Pepsi 750 ML",
                                      "price": 3800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "54156425",
                                      "name": "Pepsi 250 ML",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 5 pm, today",
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "73 ratings",
                                  "ratingCountV2": "73"
                                }
                              }
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": ["License No. 11219334001702"]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Hotel Empire",
                      "area": "Koramangala",
                      "completeAddress": "103, Industrial Area, 5th Block, Near Jyothi Nivas College, Koramangala 5th Block, Bangalore"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "4d6d0f2b-a65c-4e67-ba69-d14eee90d4ec",
  "sid": "8gpec29b-3d9e-47ce-aa35-b9951d9befd9",
  "deviceId": "73a27926-1d32-d93a-8a46-34268cac4f66",
  "csrfToken": "AFIrMeAEZHGG-BAEjPmApHNBZpoW8ab6Hlaf7HAE"
}

export default restaurantListData;